import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import translation from "../../../i18n/i18.json";
import useStyles from "./VendorDetail.css";
import React, { Fragment, useEffect, useRef, useState } from "react";
import BascInfo from "./BascInfo";
import PreparerInfo from "./PreparerInfo";
import CallerVerifierInfo from "./CallerVerifierInfo";
import ContactDetail from "./ContactDetail";
import PaymentDetail from "./PaymentDetail";
import BankDetail from "./BankDetail";
import Commercial from "./Commercial";
import MillEvaluationForm from "./MillEvaluationForm";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import {
  AdditionalDocumentDetail,
  CommercialDetail,
  MobileNo,
  VendorBankDetail,
  VendorDetailState,
  MillEvaluationFormDetail
} from "../../../reducers/vendor/VendorDetailReducer";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import {
  DropdownOptions_VendorDetail_BusinessNature,
  VendorCountry,
  NavigationPaths,
  InforDisplyaDuration,
  VendorRequestViewMode,
  DropdownOptions_VendorDetail_BankName,
  RequestStatus,
  NatureOfBusiness,
  BANKDETAILS_NOT_REQUIERD_PAYMENT_METHODS,
  ResponseObjectType,
  VendorTypeData,
  VendorForm1Modes,
  AppApprovalPoints,
  RequestTypes,
  vendorBankModifiedStatus,
  acmeNOBvalues,
  CompanyCodeData,
  FileUploadTypes,
  VendorCategoryData
} from "../../../constants/AppConstants";
//import FileDownload from "../../../components/FileDownload/FileDownload";
import { Attachment } from "../../../models/Attachment";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { VendorBlockExcemptionService } from "../../../services/VendorBlockExcemptionService";
import { FileDownloadService } from "../../../services/FileDownloadService";
import { ApprovalStatusData } from "../../../models/Approval/ApprovalStatusData";
import { UserFile } from "../../../models/UserFile";
import ApproveDialog from "../../../components/Vendor/Popup/Confirmation/ApproveDialog";
import RejectDialog from "../../../components/Vendor/Popup/Confirmation/RejectDialog";
import { FormError } from "../../../models/FormValidation/FormError";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Common } from "../../../utils/Common";
import ValidationErrors from "../../../components/ErrorList/ValidationErrors";
import { useHistory, useParams } from "react-router-dom";
import { ResponseObject } from "../../../models/ResponseObject";
import { FormUtil } from "../../../utils/FormUtil";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import { VendorAmendService } from "../../../services/VendorAmendService";
import { VendorExtendService } from "../../../services/VendorExtendService";
import { Company } from "../../../models/Company";
import { DocumentTypeData } from "../../../models/DocumentTypeData";
// import RequestChangePopUp from "../../../components/Vendor/Popup/RequestChangeDialog";
import RequestExtendPopUp from "../../../components/Vendor/Popup/RequestExtendDialog";
import Form1Data from "./Form1Data";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import CancelIcon from "@material-ui/icons/Cancel";
import { VendorCreateState } from "../../../reducers/vendor/VendorCreateReducer";
import BlockData from "./BlockData";
import BlockExcemptionData from "./BlockExcemptionData";
import { VendorBlockingService } from "../../../services/VendorBlockingService";
import { VendorBlockinViewData } from "../../../models/VendorBlocking/VendorBlockinViewData";
import { VendorBlockExcemptionViewData } from "../../../models/VendorBlocking/VendorBlockExcemptionViewData";
import { VendorDetailBankDetailMeta } from "../../../models/VendorDetail/VendorDetailBankDetailMeta";
import { AccCurency, CurrencyHouseBank } from "../../../models/AccCurency";
import { BankDetails } from "../../../models/BankDetails";
import { SortCode } from "../../../models/SortCode";
import { HouseBank } from "../../../models/HouseBank";
import { VendorDetailBasicMeta } from "../../../models/VendorDetail/VendorDetailBasicMeta";
import { BsNature } from "../../../models/BsNature";
import { VendorTitle } from "../../../models/VendorTitle";
import { VendorDetailContactMeta } from "../../../models/VendorDetail/VendorDetailContactMeta";
import { CommunicationMethod } from "../../../models/CommunicationMethod";
import { Country } from "../../../models/Country";
import { UOM } from "../../../models/UOM";
import { RegionCode } from "../../../models/RegionCode";
import { VendorDetailPaymentMeta } from "../../../models/VendorDetail/VendorDetailPaymentMeta";
import { TermsTrade } from "../../../models/TermsTrade";
import { CreditPeriodDays } from "../../../models/CreditPeriodDays";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { SettlementCurrency } from "../../../models/SettlementCurrency";
import { SVATType } from "../../../models/SVATType";
import { WHTCountry } from "../../../models/WHTCountry";
import { WHTType } from "../../../models/WHTType";
import { WHTCode } from "../../../models/WHTCode";
import { PaymentMethod } from "../../../models/PaymentMethod";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { RequestService } from "../../../services/RequestService";
import AttachmentIcon from "@material-ui/icons/Attachment";
import ExtensionIcon from "@material-ui/icons/Extension";
import BlockIcon from "@material-ui/icons/Block";
import EmailIcon from "@material-ui/icons/EmailRounded";
import { PurposeOfPayment } from "../../../models/PurposeOfPayment";
import { Department } from "../../../models/Department";
import { userInfo } from "os";
import { UserLoginState } from "../../../reducers/LoginReducer";
import IndividualPaymentDialog from "../../../components/Vendor/Popup/IndividualPaymentDialog";
import IndividualPaymentInfo from "./IndividualPaymentInfo";
import { ExtendCompnayData, IndividualPaymentRequestData } from "../../../models/VendorRequestChange/VendorRequestChangeData";
import { InstructionKey } from "../../../models/InstructionKey";
import { Util } from "../../../utils/Util";
import FileUpload from "../../../components/FileUpload/FileUpload";
import ExtendData from "./ExtendData";


// interface FormError {
//   fieldName: string;
//   errorMsg: string;
// }
// interface FormFieldMeta {
//   fieldName: string;
//   isRequired?: boolean;
//   reuiredMsg?: string;
//   formatMsg?: string;
//   isList?: boolean;
// }

//let vendorCompareObj = {};
//let vendorCompareBankObj = Object.create({});

export default function VendorDetail(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  //const basicinforef=useRef(null);
  //const vendorId = props.location.state ? props.location.state.vendorId : 23;
  let requestId = props.location.state ? props.location.state.requestId : undefined;
  const vendorId = props.location.state ? props.location.state.vendorId : undefined;
  const sAPVendorNo = props.location.state ? props.location.state.sAPVendorNo : undefined;
  const coCode = props.location.state ? props.location.state.coCode : undefined;
  const poCode = props.location.state ? props.location.state.poCode : undefined;
  const isForceEdit = props.location.state ? props.location.state.isForceEdit : undefined;
  let vendorDetailMode = props.location.state ? props.location.state.mode : VendorRequestViewMode.VendorCreate;
  //if no state load from url
  if (!props.location.state) {
    requestId = props.match.params.requestId;
  }
  //const requestNo = props.location.state ? props.location.state.requestNo : undefined;
  // const isExtend = props.location.state
  //   ? props.location.state.isExtend
  //   : undefined;
  let formValidateData: FormValidateData = { isValid: true, errorsList: [] };

  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [vendorCompareBankObj, setVendorCompareBankObj] = useState(Object.create({}));
  const [vendorCompareObj, setVendorCompareObj] = useState(Object.create({}));
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);
  //quick fix
  if (vendorDetail && vendorDetail.requestId > 0) {
    vendorDetailMode = vendorDetail.requestTypeId == RequestTypes.VendorAmend ? VendorRequestViewMode.VendorAmend
      : vendorDetail.requestTypeId == RequestTypes.VendorBlock ? VendorRequestViewMode.VendorBlock
        : vendorDetail.requestTypeId == RequestTypes.VendorExtend ? VendorRequestViewMode.VendorExtend
          : vendorDetail.requestTypeId == RequestTypes.VendorIndividualPay ? VendorRequestViewMode.VendorIndividualPay
            : vendorDetail.requestTypeId == RequestTypes.VendorBlockExcemption ? VendorRequestViewMode.VendorBlockExcemption
              : VendorRequestViewMode.VendorCreate;
  }


  const createVendor: VendorCreateState = useSelector<
    RootState,
    VendorCreateState
  >((state) => state.vendorCreateDetails);

  const [openAttchmentsDialog, setOpenAttchmentsDialog] = useState(false);
  const [attchments, setAttachments] = useState<Attachment[]>([]);

  const [openApprove, setOpenApprove] = useState(false);
  const [dataToApprove, setDataToApprove] = useState<ApprovalStatusData>();
  const [openReject, setOpenReject] = useState(false);
  const [openValidateErrDialog, setOpenValidateErrDialog] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [openRequestExtend, setOpenRequestExtend] = useState(false);
  const [openIndividualPayment, setOpenIndividualPayment] = useState(false);
  const [requestChangeCodeList, setRequestChangeCodeList] = useState(Array<Company>());
  const [departmentList, setDepartmentList] = useState(Array<Department>());
  const [requestchangeTitle, setRequestchangeTitle] = useState("");
  const [isIndividualPaymentEditMode, setIsIndividualPaymentEditMode] = useState(false);
  const [docUploadTypes, setDocUploadTypes] = useState(Array<DocumentTypeData>());
  const [selectedDocTypeId, setSelectedDocTypeId] = useState<number>(0);



  const initialBlockViewState: VendorBlockinViewData = {
    typeOfBlocks: [],
    reasonForBlockId: 0,
    reasonForBlockDesc: "",
    companyCodes: [],
    poCodes: [],
    paymentBlockDesc: "",
    reasonForBlockOtherReason: ""
  };
  const initialBlockExcemptionViewState: VendorBlockExcemptionViewData = {
    extensionReason: "",
    companyCode: "",
    poCodes: [],
    extensionPeriod: 0
  };
  const [blockViewData, setBlockViewData] = useState<VendorBlockinViewData>(initialBlockViewState);
  const [extendViewData, setExtendViewData] = useState(Array<ExtendCompnayData>());
  const [blockExcemptionViewData, setBlockExcemptionViewData] = useState<VendorBlockExcemptionViewData>(
    initialBlockExcemptionViewState
  );
  const [bsnature, setBsnature] = useState(Array<BsNature>());
  const [vendotitle, setVendotitle] = useState(Array<VendorTitle>());

  const [comunctionmethods, setComunctionmethods] = useState(
    Array<CommunicationMethod>()
  );
  const [countries, setCountries] = useState(Array<Country>());
  const [regioncodes, setRegioncodes] = useState(Array<RegionCode>());
  const [uomData, setUOMData] = useState(Array<string>());


  const [termstrade, setTermstrade] = useState(Array<TermsTrade>());
  const [crediperioddays, setCrediperioddays] = useState(Array<CreditPeriodDays>());
  const [settlementcurrency, setSettlementcurrency] = useState(Array<SettlementCurrency>());
  const [svattypes, setSvattypes] = useState(Array<SVATType>());
  const [whtcountries, setWhtcountries] = useState(Array<Country>());
  const [whttypes, setWhttypes] = useState(Array<WHTType>());
  const [whtcodes, setWhtcodes] = useState(Array<WHTCode>());
  const [paymentmethod, setPaymentmethod] = useState(Array<PaymentMethod>());

  const [acccorencies, setAcccorencies] = useState(Array<AccCurency>());
  const [sortcodes, setSortcodes] = useState(Array<SortCode>());
  const [housebanks, setHousebanks] = useState(Array<HouseBank>());
  const [bankDetails, setBankDetails] = useState(Array<BankDetails>());
  const [purposeList, setPurposeList] = useState(Array<PurposeOfPayment>());


  const compareVendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  const [instructionkeys, setInstructionkey] = useState(
    Array<InstructionKey>()
  );
  const [currencyHouseBanks, setCurrencyHouseBanks] = useState(
    Array<CurrencyHouseBank>()
  );

  //isInitialVendorDetailData - to avoid getting data on state changes as all data is fetched in initial data load.
  const [isInitialVendorDetailData, setIsInitialVendorDetailData] = useState(false);
  const [selectedHouseBanks, setSelectedHouseBanks] = useState(
    Array<CurrencyHouseBank>()
  );

  const [uploadtableData, setUploadTableData] = useState<AdditionalDocumentDetail[]>([]);
  const uploadtableColumnData = [
    { name: translation.vendor_detail_additionaldoc_uploadtype_lbl },
    { name: translation.vendor_detail_additionaldoc_upload_lbl },
  ];

  const isAvailableForVendorCountry = (fieldname: string) => {
    switch (fieldname) {
      case "WHTCountry":
        return vendorDetail.AddressCoutry === VendorCountry.India
          ? true
          : false;
        break;
      case "WHTType":
        return vendorDetail.AddressCoutry === VendorCountry.India
          ? true
          : false;
        break;
      case "WHTCode":
        return vendorDetail.AddressCoutry === VendorCountry.India
          ? true
          : false;
        break;
      case "ExemptionNumber":
        return vendorDetail.AddressCoutry === VendorCountry.India
          ? true
          : false;
        break;
      case "Exemption":
        return vendorDetail.AddressCoutry === VendorCountry.India
          ? true
          : false;
        break;
      case "ExemptFrom":
        return vendorDetail.AddressCoutry === VendorCountry.India
          ? true
          : false;
        break;
      case "ExemptTo":
        return vendorDetail.AddressCoutry === VendorCountry.India
          ? true
          : false;
        break;
      case "Discription":
        return vendorDetail.AddressCoutry === VendorCountry.India
          ? true
          : false;
        break;

      default:
        break;
    }
  };

  React.useEffect(() => {
    if (vendorDetail.CompanyCode) {
      VendorAmendService.getInstructionKeyData(
        vendorDetail.CompanyCode.countryCode,
        function (instructionKeys: Array<InstructionKey>) {
          setInstructionkey(instructionKeys);
        },
        function (error: Error) {
          console.log(error);
          setInstructionkey([]);
        }
      )
      getUploadTypeData()
    }
  }, [vendorDetail.CompanyCode])

  useEffect(() => {
    dispatch(
      AllActions.vendorDetailActions.updateDataField(
        "additionalDocumentList",
        uploadtableData
      )
    );
  }, [uploadtableData, dispatch]);

  const isFielsAvailable = (fieldName: string) => {
    if (fieldName == "IsVatRegistered"
      || fieldName == "IsSvatRegistered"
      || fieldName == "PanNumber"
      || fieldName == "TaxNumber"
      || fieldName == "trc"
    ) {
      return Common.getSapSystem() != "S4" || vendorDetail.CompanyCode.code != CompanyCodeData.ACMEusa;
    } else if (fieldName == "SettlementCurrencies") {
      return Common.getSapSystem() != "S4";
    }
  }

  const isWHTAvailable = () => {
    //return vendorDetail.AddressCoutry === VendorCountry.India && createVendor.VendorType !== VendorTypeData.Employee;
    return (
      createVendor.isWhtAvailable &&
      createVendor.VendorType !== VendorTypeData.Employee
    );
  };

  const setPreparerData = () => {
    if (isEditableMode()) {
      if (Common.isVendor()) {//if external user set values blank and force to enter each time
        if (isInitialVendorDetailData) {
          vendorDetail.FilledByName = "";
          vendorDetail.FilledByEmail = "";
        }
      } else {
        let loggedUser: UserLoginState = JSON.parse(Common.getLoginUserData()!);
        vendorDetail.FilledByName = loggedUser.userName;
        vendorDetail.FilledByEmail = loggedUser.email;
      }
    }
  };

  const getCurrencyHouseBankData = () => {
    VendorMasterData.getCurrencyHouseBankMapping(
      function (c: Array<CurrencyHouseBank>) {
        setCurrencyHouseBanks(c);
        console.log(currencyHouseBanks);
      },
      function (error: Error) {
        console.log(error);
        setCurrencyHouseBanks([]);
      }
    )
  }

  const isPanTaxRequired = () => {
    return (Common.getSapSystem() != "S4" || vendorDetail.CompanyCode.code != CompanyCodeData.ACMEusa)
      && vendorDetail.AddressCoutry === VendorCountry.India
      && vendorDetail.CompanyCode.countryCode === VendorCountry.India
      && createVendor.VendorType !== VendorTypeData.Employee;
  };

  const isTrcRequired = () => {
    return (Common.getSapSystem() != "S4" || vendorDetail.CompanyCode.code != CompanyCodeData.ACMEusa)
      && vendorDetail.CompanyCode.countryCode == VendorCountry.India
      && vendorDetail.AddressCoutry != VendorCountry.India
      && createVendor.VendorType === VendorTypeData.Services;
  };

  const isTaxDetailsAvailable = (taxType: string) => {
    let sapSystem = Common.getSapSystem();
    if (taxType == "Tax1099") {
      return (sapSystem === "S4" && vendorDetail.CompanyCode.code === CompanyCodeData.ACMEusa);
    } else {
      return (sapSystem != "S4" || vendorDetail.CompanyCode.code != CompanyCodeData.ACMEusa)
        && createVendor.VendorType !== VendorTypeData.Employee;
    }
  };

  const is1099Required = () => {
    return (isTaxDetailsAvailable("Tax1099") &&
      ((Common.getSapSystem() === "S4" &&
        vendorDetail.AddressCoutry === VendorCountry.USA &&
        vendorDetail.CompanyCode.code == CompanyCodeData.ACMEusa))) ? true : false;
  };

  // let pareralRequestsCounter = 0;
  // let pareralRequestsCount = 1;

  const getErrorState = (input: string) => {
    var errIndex = formErrors.findIndex(function (row) {
      return row.fieldName === input && row.errorMsg;
    });
    return errIndex !== -1 ? true : false;
  };

  const getCompareField = (propertyName: string) => {
    return vendorCompareObj.hasOwnProperty(propertyName) ? false : true;
  };
  const getBankGridCompareField = (key: string, propertyName: string) => {
    let bankObj = vendorCompareBankObj[key];
    if (bankObj) {
      return bankObj.hasOwnProperty(propertyName);
    }
  };

  function handleOnBlur(input: string): (e: any) => void {
    return (e: any) => {
      dispatch(
        AllActions.vendorDetailActions.updateDataField(
          input,
          e.target.value.trim()
        )
      );
    };
  }

  const handleVatEnabledChange = (input: string, isChecked: boolean) => {
    if (vendorDetail.AddressCoutry === VendorCountry.SriLanka && !isChecked) {
      dispatch(
        AllActions.alertDialogActions.openAlertDialog(
          translation.vendor_detail_paymentdetails_vat_alert_title,
          translation.vendor_detail_paymentdetails_vat_alert_msg,
          translation.vendor_detail_paymentdetails_vat_alert_yesbtn,
          function () {
            dispatch(AllActions.alertDialogActions.closeAlertDialog());
            dispatch(AllActions.vendorDetailActions.updateDataField(input, isChecked));
            dispatch(AllActions.vendorDetailActions.updateDataField("SVATRegistered", false));
          },
          translation.vendor_detail_paymentdetails_vat_alert_nobtn,
          function () {
            dispatch(AllActions.alertDialogActions.closeAlertDialog());
          }
        )
      );
    } else {
      dispatch(AllActions.vendorDetailActions.updateDataField(input, isChecked));
      if (!isChecked) {
        dispatch(AllActions.vendorDetailActions.updateDataField("SVATRegistered", false));
      }
    }
  }

  const handleSvatEnabledChange = (input: string, isChecked: boolean) => {
    if (vendorDetail.AddressCoutry === VendorCountry.SriLanka && !isChecked) {
      dispatch(
        AllActions.alertDialogActions.openAlertDialog(
          translation.vendor_detail_paymentdetails_svat_alert_title,
          translation.vendor_detail_paymentdetails_svat_alert_msg,
          translation.vendor_detail_paymentdetails_svat_alert_yesbtn,
          function () {
            dispatch(AllActions.alertDialogActions.closeAlertDialog());
            dispatch(AllActions.vendorDetailActions.updateDataField(input, isChecked));
          },
          translation.vendor_detail_paymentdetails_svat_alert_nobtn,
          function () {
            dispatch(AllActions.alertDialogActions.closeAlertDialog());
          }
        )
      );
    } else {
      dispatch(AllActions.vendorDetailActions.updateDataField(input, isChecked));
      if (isChecked) {
        dispatch(AllActions.vendorDetailActions.updateDataField("VATRegisterd", isChecked));
      }
    }
  }

  const handleChange = (input: string) => (e: any, value: any) => {
    if (e.target.type === "checkbox") {
      if (input === "SVATRegistered") {
        handleSvatEnabledChange(input, e.target.checked);
      } else if (input === "VATRegisterd") {
        handleVatEnabledChange(input, e.target.checked);
      } else {
        dispatch(
          AllActions.vendorDetailActions.updateDataField(
            input,
            e.target.checked
          )
        );
      }
    } else if (input === "NatureOfbusiness") {
      if (
        e.target.value !== NatureOfBusiness.Partnership &&
        e.target.value !== NatureOfBusiness.SolePropritery
      ) {
        //clear bank details
        if (vendorDetail.requestTypeId === RequestTypes.VendorCreate) {
          vendorDetail.bankDetailList.forEach((bnk) => {
            dispatch(
              AllActions.vendorDetailActions.clearBankField(bnk.id, "beneficiaryAccName")
            );
          });
        }
        else if (vendorDetail.requestTypeId === RequestTypes.VendorAmend) {
          vendorDetail.bankDetailList.forEach((bnk) => {
            if (getBankGridCompareField(bnk.beneficiaryAccName, "beneficiaryAccName") ||
              bnk.id === -1 || bnk.modifiedStatus === 1) {
              dispatch(
                AllActions.vendorDetailActions.clearBankField(bnk.id, "beneficiaryAccName")
              );
            }
          });
        }
      }
      if (
        e.target.value === NatureOfBusiness.PVTLimited ||
        e.target.value === NatureOfBusiness.Partnership ||
        e.target.value === NatureOfBusiness.Public ||
        e.target.value === NatureOfBusiness.Government
      ) {
        dispatch(
          AllActions.vendorDetailActions.updateDataField("vendorNic", "")
        );
        dispatch(
          AllActions.vendorDetailActions.updateDataField("EmployeeEPF", "")
        );
      } else if (e.target.value === NatureOfBusiness.SolePropritery) {
        dispatch(
          AllActions.vendorDetailActions.updateDataField("BusRegNumber", "")
        );
        dispatch(
          AllActions.vendorDetailActions.updateDataField("EmployeeEPF", "")
        );
      } else if (e.target.value === NatureOfBusiness.MASEmployee) {
        // dispatch(
        //   AllActions.vendorDetailActions.updateDataField("vendorNic", "")
        // );
        dispatch(
          AllActions.vendorDetailActions.updateDataField("BusRegNumber", "")
        );
      }
      dispatch(
        AllActions.vendorDetailActions.updateDataField(input, e.target.value)
      );
    } else if (input === "PrefPayMethod") {
      if (vendorDetail.PrefPayMethod.length < 10) {
        dispatch(
          AllActions.vendorDetailActions.updateDataField(input, e.target.value)
        );
      } else {
        dispatch(AllActions.infoActions.openInforWarn(
          `${translation.vendordetail_vendor_select_popup_slectedmax_msg} 10`,
          InforDisplyaDuration.common
        ));
      }
    }
    else if (input === "currencyId") {
      let curr = e.target.value;
      let houseBanksList = currencyHouseBanks.filter((element) => {
        return element.currencyCode === curr;
      });
      setSelectedHouseBanks(houseBanksList);
      dispatch(
        AllActions.vendorDetailActions.updateDataField(input, e.target.value)
      );
      if (houseBanksList.length === 1) {
        dispatch(
          AllActions.vendorDetailActions.updateDataField("HouseBank", houseBanksList[0].houseBank)
        );
      }
    }
    else if (input === "AddressCoutry") {
      if (value == "LK" && (Common.getSapSystem() != "S4" || vendorDetail.CompanyCode.code != CompanyCodeData.ACMEusa)) {
        dispatch(AllActions.vendorDetailActions.updateDataField("VATRegisterd", true));
        dispatch(AllActions.vendorDetailActions.updateDataField("SVATRegistered", true));
      } else {
        dispatch(AllActions.vendorDetailActions.updateDataField("VATRegisterd", false));
        dispatch(AllActions.vendorDetailActions.updateDataField("SVATRegistered", false));
      }
    }
    /*     else if (input === "MobileNumberText") {
          if (e.target.value && e.target.value.trim().length > 0) {
            dispatch(AllActions.vendorDetailActions.updateDataField("MobileNumbers", [{ mobileNumber: e.target.value, isChecked: true }]));
          } else {
            dispatch(AllActions.vendorDetailActions.updateDataField("MobileNumbers", []));
          }
          dispatch(AllActions.vendorDetailActions.updateDataField(input, e.target.value));
        } */


    else if (input === "MobileNumberText") {
      const mobileValue = e.target.value.replace(/\D/g, "");

      if (mobileValue && mobileValue.trim().length > 0) {
        dispatch(
          AllActions.vendorDetailActions.updateDataField("MobileNumbers", [
            { mobileNumber: mobileValue, isChecked: true }
          ])
        );
      } else {
        dispatch(AllActions.vendorDetailActions.updateDataField("MobileNumbers", []));
      }

      dispatch(AllActions.vendorDetailActions.updateDataField(input, mobileValue));

      setFormErrors((prev) => {
        const filtered = prev.filter((err) => err.fieldName !== "MobileNumberText");

        if (
          mobileValue.length > 0 &&
          !FormUtil.isValidMobileNumberForSms(mobileValue)
        ) {
          return [
            ...filtered,
            {
              fieldName: "MobileNumberText",
              errorMsg: translation.vendor_crete_form1_mobilenformt_error,
            },
          ];
        }

        return filtered;
      });
    }
    else if (input === "FilledByMobile") {
      const mobileValue = e.target.value.replace(/\D/g, "");

      dispatch(
        AllActions.vendorDetailActions.updateDataField(input, mobileValue)
      );

      setFormErrors((prev) => {
        const filtered = prev.filter((err) => err.fieldName !== "FilledByMobile");

        if (
          mobileValue.length > 0 &&
          !FormUtil.isValidVendorPhoneNumber(mobileValue)
        ) {
          return [
            ...filtered,
            {
              fieldName: "FilledByMobile",
              errorMsg: "Preparer Mobile Number format is invalid",
            },
          ];
        }

        return filtered;
      });
    }
    else {
      dispatch(
        AllActions.vendorDetailActions.updateDataField(input, e.target.value)
      );
    }
  };

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  const isDisplayRegistrationNumber = () => {
    return (
      vendorDetail.NatureOfbusiness === NatureOfBusiness.PVTLimited ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.Partnership ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.Public ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.Government ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.CCorporation ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.SCorporation ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.LimitedLiabilityCompany ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.TrustEstate
    );
  };
  const isPORequest = () => {
    return vendorDetail.poCodes && vendorDetail.poCodes.length > 0;
  };

  const is2MobileSelected = () => {
    let arr = vendorDetail.MobileNumbers.filter(function (contact: MobileNo) {
      return contact.isChecked == true;
    });
    return arr.length == 2;
  };

  const isRegionRequired = () => {
    return (vendorDetail.AddressCoutry == VendorCountry.USA || vendorDetail.AddressCoutry == VendorCountry.Canada);
  };
  // const isSwiftCodeRequired = () => {
  //   return vendorDetail.AddressCoutry !== VendorCountry.USA;
  // };

  // const isSortCodeRequired = () => {
  //   return vendorDetail.AddressCoutry === VendorCountry.USA;
  // };

  const isBankDetaildRequired = () => {
    if (vendorDetail.PrefPayMethod && vendorDetail.PrefPayMethod.length > 0) {
      return !vendorDetail.PrefPayMethod.every((paymentcode) => {
        return BANKDETAILS_NOT_REQUIERD_PAYMENT_METHODS.includes(paymentcode);
      });
      // return !BANKDETAILS_NOT_REQUIERD_PAYMENT_METHODS.includes(
      //   vendorDetail.PrefPayMethod
      // );
    }
    return true;
  };

  /* const validateVendorCommercialData = (isSubmit: boolean) => {
    if (!isSubmit) {
      setFormErrors([]);
    }
    if (vendorDetail.vendorCategoryId == VendorCategoryData.RM || vendorDetail.vendorCategoryId == VendorCategoryData.NonRM || vendorDetail.vendorCategoryId == VendorCategoryData.Services) {
      if (Common.getSapSystem() != "S4" && vendorDetail.vendorCategoryId == VendorCategoryData.RM) //Millevaluation validation
      {
         if (vendorDetail.millEvaluationFormList.length > 0) {
          var detail = vendorDetail.millEvaluationFormList.filter(row => row.uploadFile == null);
          if (detail.length > 0) {
            formValidateData.errorsList.push({
              fieldName: "MillEvaluation",
              errorMsg: translation.vendor_detail_millevaluationform_required
            });
            formValidateData.isValid = false;
          } 
        } 
      }
      // if (vendorDetail.commercialDetailList.length == 0 && vendorDetail.isBulk) {
      //   formValidateData.errorsList.push({
      //     fieldName: "Commercial",
      //     errorMsg: translation.vendor_detail_commercialdetail_required
      //   });
      //   formValidateData.isValid = false;
      // }
      else {
        if (!isSubmit) {
          return true;
        }
        else {
          if (formValidateData.errorsList.length > 0)
            formValidateData.isValid = false;
          else
            formValidateData.isValid = true;
        }
      }
      if (!isSubmit) {
        setFormErrors(formValidateData.errorsList);
        dispatch(AllActions.backDropActions.closeBackDrop());
        return formValidateData.isValid;
      }
      else {
        if (formValidateData.errorsList.length > 0)
          formValidateData.isValid = false;
        else
          formValidateData.isValid = true;
      }
    }
    else {
      if (!isSubmit) {
        return true;
      }
      else {
        if (formValidateData.errorsList.length > 0)
          formValidateData.isValid = false;
        else
          formValidateData.isValid = true;
      }
    }

  }; */

  const validateData = () => {
    setFormErrors([]);
    const validateFieldsData: Array<FormFieldMeta> = [
      {
        fieldName: "VendorName",
        isRequired: true,
        reuiredMsg: "Vendor Name is required",
      },
      {
        fieldName: "NatureOfbusiness",
        isRequired: true,
        reuiredMsg:
          translation.vendor_crete_form1_vendornature_section_title +
          " is required",
      },
      { fieldName: "Title", isRequired: true, reuiredMsg: "Title is required" },
      {
        fieldName: "PurposePayment",
        isRequired: false,
        reuiredMsg: "Purpose of the payment is required",
      },
      {
        fieldName: "BusRegNumber",
        isRequired: isDisplayRegistrationNumber(),
        reuiredMsg: "BR / CIN / GST is required",
      },
      {
        fieldName: "vendorNic",
        isRequired:
          vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery ||
            vendorDetail.NatureOfbusiness === NatureOfBusiness.MASEmployee
            ? true
            : false,
        reuiredMsg:
          vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery
            ? "NIC / BR / CIN / GST is required"
            : "NIC is required",
      },
      {
        fieldName: "EmployeeEPF",
        isRequired:
          vendorDetail.NatureOfbusiness === NatureOfBusiness.MASEmployee
            ? true
            : false,
        reuiredMsg: "Employee EPF is required",
      },
      {
        fieldName: "AddressNumberStreet",
        isRequired: true,
        reuiredMsg: "Address Number & Street is required",
      },
      {
        fieldName: "AddressPostalCode",
        isRequired: true,
        reuiredMsg: "Postal Code is required",
        formatFunc: FormUtil.isValidPostalCode.bind(
          vendorDetail.AddressPostalCode
        ),
        formatMsg: translation.vendor_detail_form2_postalcodefomat_error,
      },
      {
        fieldName: "AddressCity",
        isRequired: true,
        reuiredMsg: "City is required",
      },
      // {
      //   fieldName: "AddressCoutry",
      //   isRequired: true,
      //   reuiredMsg: "Country is required",
      // },
      {
        fieldName: "RegionCode",
        isRequired: isRegionRequired(),
        reuiredMsg: "Region is required",
      },
      {
        fieldName: "PaymentContactPersonDesig",
        isRequired: true,
        reuiredMsg: "Contact person designation is required",
      },
      {
        fieldName: "PaymentContactPersonName",
        isRequired: true,
        reuiredMsg: "Name of Contact Person for payments is required",
      },
      {
        fieldName: "PaymentContactPersonName2",
        isRequired: false,
        reuiredMsg: "Name of Contact Person 2 for payments is required",
      },
      {
        fieldName: "MobileNumberText",
        isRequired: true,
        reuiredMsg: "Mobile Numbers is required",
        formatFunc: vendorDetail.MobileNumberText
          ? FormUtil.isValidMobileNumberForSms.bind(vendorDetail.MobileNumberText)
          : undefined,
        formatMsg: translation.vendor_crete_form1_mobilenformt_error,
      },
      {
        fieldName: "EmailNoteList",
        isRequired: true,
        reuiredMsg: "One or more Email addresses is required",
        isList: true,
      },
      {
        fieldName: "CompanyWebSite",
        isRequired: false,
        reuiredMsg: "CompanyWebSite is required",
      },
      {
        fieldName: "PrefCommunMethod",
        isRequired: true,
        reuiredMsg: "Preferred Communication Method is required",
      },
      // {
      //   fieldName: "TermsOfTrade",
      //   isRequired: isPORequest(), //vendorDetail.IsForeignSupplier ? true : false,
      //   reuiredMsg: "Terms Of Trade is required",
      // },
      {
        fieldName: "MobileNumberText",
        isRequired: true,//is2MobileSelected(),
        reuiredMsg: "Mobile number is required",
      },
      // {
      //   fieldName: "PrefPayMethod",
      //   isRequired: true,
      //   isList: true,
      //   reuiredMsg: "Preferred Payment Method is required",
      // },
      // {
      //   fieldName: "CreditPeriodDays",
      //   isRequired: true,
      //   reuiredMsg: "Credit Period Days is required",
      // },
      // {
      //   fieldName: "orderCurrency",
      //   isRequired: isPORequest(),
      //   reuiredMsg: "Order Currency is required",
      // },
      // {
      //   fieldName: "alternativeCurrency",
      //   isRequired: false,
      //   reuiredMsg: "Alternative Currency is required",
      //   isList: true,
      // },
      {
        fieldName: "SVATType",
        isRequired: false,
        reuiredMsg: "SVAT Type is required",
      },
      {
        fieldName: "SVATContactNumber",
        isRequired: vendorDetail.SVATRegistered ? true : false,
        reuiredMsg: "SVAT Contact Number is required",
        formatFunc: vendorDetail.SVATContactNumber
          ? FormUtil.isValidVendorPhoneNumber.bind(
            vendorDetail.SVATContactNumber
          )
          : undefined,
        formatMsg: "SVAT Contact Number Format is invalid",
      },
      {
        fieldName: "SVATContactEmail",
        isRequired: vendorDetail.SVATRegistered ? true : false,
        formatFunc: vendorDetail.SVATContactEmail
          ? FormUtil.isValidEmail.bind(vendorDetail.SVATContactEmail)
          : undefined,
        reuiredMsg: "SVAT Contact Email is required",
        formatMsg: "SVAT Contact Email Format is invalid",
      },
      {
        fieldName: "VATNumber",
        isRequired: vendorDetail.VATRegisterd ? true : false,
        reuiredMsg: "VAT Number is required",
      },
      {
        fieldName: "SVATNumber",
        isRequired: vendorDetail.SVATRegistered ? true : false,
        reuiredMsg: "SVAT Number is required",
      },
      {
        fieldName: "SWATType",
        isRequired: false,
        reuiredMsg: "SWAT Type is required",
      },
      {
        fieldName: "TinNic",
        isRequired: (isTaxDetailsAvailable("TinNic") &&
          ((vendorDetail.AddressCoutry === VendorCountry.USA && acmeNOBvalues.includes(vendorDetail.NatureOfbusiness))
            || (vendorDetail.AddressCoutry === VendorCountry.SriLanka))) ? true : false,
        reuiredMsg: "TIN/ NIC is required",
      },
      {
        fieldName: "Tax1099",
        isRequired: is1099Required(),
        reuiredMsg: "TIN/SSN/EIN is required",
      },
      {
        fieldName: "TaxConPersnName",
        isRequired: vendorDetail.VATRegisterd ? true : false,
        reuiredMsg: "Tax Contact Person Name is required",
      },
      {
        fieldName: "TaxConPersnConNum",
        isRequired: vendorDetail.VATRegisterd ? true : false,
        reuiredMsg: "Tax Contact Person Number is required",
      },
      {
        fieldName: "LiableForWHT",
        isRequired: false,
        reuiredMsg: "Liable For WHT is required",
      },
      {
        fieldName: "WHTCountry",
        isRequired: false,
        reuiredMsg: "WHT Country is required",
      },
      {
        fieldName: "WHTType",
        isRequired: false,
        reuiredMsg: "WHT Type is required",
      },
      {
        fieldName: "WHTCode",
        isRequired: false,
        reuiredMsg: "WHTCode is required",
      },
      {
        fieldName: "ExemptionNumber",
        isRequired: false,
        reuiredMsg: "Exemption Number is required",
      },
      {
        fieldName: "Exemption",
        isRequired: false,
        reuiredMsg: "Exemption is required",
      },
      {
        fieldName: "ExemptFrom",
        isRequired: false,
        reuiredMsg: "Exempt From is required",
      },
      {
        fieldName: "ExemptTo",
        isRequired: false,
        reuiredMsg: "Exempt To is required",
      },
      {
        fieldName: "Discription",
        isRequired: false,
        reuiredMsg: "Discription is required",
      },
      {
        fieldName: "ForeignEntityReq",
        isRequired: false,
        reuiredMsg: "Foreign Entity's Requirement is required",
      },
      {
        fieldName: "AvailabilityDT",
        isRequired: false,
        reuiredMsg: "Availability DT is required",
      },
      {
        fieldName: "TaxRateDT",
        isRequired: false,
        reuiredMsg: "TaxRate DT is required",
      },
      {
        fieldName: "PANNumber",
        isRequired: isPanTaxRequired(),
        reuiredMsg: "PAN Number is required",
      },
      {
        fieldName: "TaxNumber",
        isRequired: isPanTaxRequired(),
        reuiredMsg: "Tax Number is required",
      },
      {
        fieldName: "trc",
        isRequired: isTrcRequired(),
        reuiredMsg: "TRC is required",
      },
      {
        fieldName: "bankDetailList",
        isRequired: isBankDetaildRequired(),
        reuiredMsg: "One or more Bank Detail is required",
        isList: true,
      },
      {
        fieldName: "instructionKey",
        isRequired: false,
        reuiredMsg: "Instruction Key is required",
      },
      {
        fieldName: "HouseBank",
        isRequired: false,
        reuiredMsg: "House Bank is required",
      },
      {
        fieldName: "ReconAC",
        isRequired: false,
        reuiredMsg: "Recon A/C is required",
      },
      {
        fieldName: "PurposeCode",
        isRequired: false,
        reuiredMsg: "Purpose Code is required",
      },
      {
        fieldName: "AccoutingClark",
        isRequired: false,
        reuiredMsg: "Accouting Clark is required",
      },
      {
        fieldName: "HoBeneficiaryCatIndo",
        isRequired: false,
        reuiredMsg: "Beneficiary Category(Indo) is required",
      },
      {
        fieldName: "HopurposeofTransIndo",
        isRequired: !Common.isVendor() && vendorDetail.AddressCoutry === VendorCountry.Indonesia &&
          vendorDetail.CompanyCode.countryCode == VendorCountry.Indonesia
          ? true : false,
        reuiredMsg: "Purpose Of Transfer(Indo) is required",
      },
      {
        fieldName: "HoBeneAffiliationStatusIndo",
        isRequired: false,
        reuiredMsg: "Bene Affiliation Status(Indo) is required",
      },
      {
        fieldName: "HoPayableLocationIndia",
        isRequired: false, //!Common.isVendor() && vendorDetail.AddressCoutry === VendorCountry.India && // removed required based on CR
        reuiredMsg: "Payable Location(India) is required",
      },
      {
        fieldName: "HoPurposePayIndia",
        isRequired: !Common.isVendor() && vendorDetail.AddressCoutry === VendorCountry.India &&
          vendorDetail.CompanyCode.countryCode == VendorCountry.India ? true : false,
        reuiredMsg: "Purpose Pay(India) is required",
      },
      {
        fieldName: "simodis",
        isRequired: !Common.isVendor() && ((vendorDetail.CompanyCode.countryCode == VendorCountry.Indonesia &&
          vendorDetail.AddressCoutry != VendorCountry.Indonesia) ||
          (vendorDetail.CompanyCode.countryCode == VendorCountry.Kenya &&
            vendorDetail.AddressCoutry != VendorCountry.Kenya))
          ? true : false,
        reuiredMsg: "simodis",
      },
      {
        fieldName: "AccoutingEmail",
        isRequired: false,
        reuiredMsg: "Accouting Email is required",
      },
      {
        fieldName: "FilledByName",
        isRequired: true,
        reuiredMsg: "Filled By Name is required",
      },
      {
        fieldName: "FilledByEmail",
        isRequired: true,
        reuiredMsg: "Filled By Email is required",
      },
      {
        fieldName: "FilledByMobile",
        isRequired: true,
        reuiredMsg: "Filled By Mobile is required",
      },
      {
        fieldName: "FilledByDesignation",
        isRequired: true,
        reuiredMsg: "Filled By Designation is required",
      },
    ];
    formValidateData = FormUtil.validateFields(
      validateFieldsData,
      vendorDetail
    );
    // if (!is2MobileSelected()) {
    //   formValidateData.errorsList.push({
    //     fieldName: "MobileNumbers",
    //     errorMsg: "2 selected contact numbers are required"
    //   });
    //   formValidateData.isValid = false;
    // }
    //todo move to seperate funciton
    //validate with form 1 data
    if (Common.isVendor()) {
      //vendor Name
      if (createVendor.VendorName?.trim().toLowerCase() != vendorDetail.VendorName?.trim().toLowerCase()) {
        formValidateData.errorsList.push({
          fieldName: "VendorName",
          errorMsg: "Vendor Name is not matching with the provided information. Please contact Vendor onboarding team."
        });
        formValidateData.isValid = false;
      }
      //vendor mobile
      let matchingMobile = vendorDetail.MobileNumbers
        ? vendorDetail.MobileNumbers.find((m) => { return m.mobileNumber?.trim().toLowerCase() == createVendor.MobileNumber?.trim().toLowerCase() })
        : null;
      if (!matchingMobile) {
        formValidateData.errorsList.push({
          fieldName: "MobileNumbers",
          errorMsg: "Vendor Mobile number/s are not matching with the provided information. Please contact Vendor onboarding team."
        });
        formValidateData.isValid = false;
      }
      //vendor email
      let matchingEmail = vendorDetail.EmailNoteList
        ? vendorDetail.EmailNoteList.find((m) => { return m.emailAddress?.trim().toLowerCase() == createVendor.Email?.trim().toLowerCase() })
        : null;
      if (!matchingEmail) {
        formValidateData.errorsList.push({
          fieldName: "EmailNoteList",
          errorMsg: "Vendor Email/s are not matching with the provided information. Please contact Vendor onboarding team."
        });
        formValidateData.isValid = false;
      }

    }
    // vendor banks
    if (vendorDetail.NatureOfbusiness === NatureOfBusiness.Partnership ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery) {
      let matchingBankCount = vendorDetail.bankDetailList != null && vendorDetail.bankDetailList.length > 0
        ? vendorDetail.bankDetailList.filter((bnk) => { return !bnk.beneficiaryAccName && bnk.modifiedStatus !== 2; })
        : [];
      if (matchingBankCount.length > 0) {
        formValidateData.errorsList.push({
          fieldName: "bankDetailAccountName",
          errorMsg: "Vendor bank benificiary account name cannot be empty."
        });
        formValidateData.isValid = false;
      }
    }
    //Specical char validation
    if (Util.hasSpecialCharacters(vendorDetail.AddressNumberStreet)) {
      formValidateData.errorsList.push({
        fieldName: "AddressNumberStreet",
        errorMsg: "Vendor Address Number & Street has invalid characters."
      });
      formValidateData.isValid = false;
    }
    if (Util.hasSpecialCharacters(vendorDetail.VendorName)) {
      formValidateData.errorsList.push({
        fieldName: "VendorName",
        errorMsg: "Vendor Name has invalid characters."
      });
      formValidateData.isValid = false;
    }
    if (Util.hasSpecialCharacters(vendorDetail.BusRegNumber)) {
      formValidateData.errorsList.push({
        fieldName: "BusRegNumber",
        errorMsg: "Vendor BR has invalid characters."
      });
      formValidateData.isValid = false;
    }
    //if amend request validate Vendor name, BR, Nature of business change at once
    //Keep this to last
    customValueValidation(formValidateData);
    // validateVendorCommercialData(true);

    setFormErrors(formValidateData.errorsList);
    return formValidateData.isValid;
  };

  const customValueValidation = (formValidationdata: FormValidateData) => {
    //for amend requests dont allow to change all following at once
    //Show only all other validations done
    if (formValidateData.isValid && vendorDetail.requestTypeId == RequestTypes.VendorAmend) {
      let nameChanged = vendorDetail.originalVendorName
        ? vendorDetail.originalVendorName.trim().toUpperCase() != vendorDetail.VendorName.trim().toUpperCase()
        : false
      let brChanged = vendorDetail.originalBusRegNumber
        ? vendorDetail.originalBusRegNumber.trim().toUpperCase() != vendorDetail.BusRegNumber.trim().toUpperCase()
        : false
      let nbChanged = vendorDetail.originalNatureOfbusiness
        ? vendorDetail.originalNatureOfbusiness.trim().toUpperCase() != vendorDetail.NatureOfbusiness.trim().toUpperCase()
        : false
      if (nameChanged && brChanged && nbChanged) {
        formValidateData.errorsList.push({
          fieldName: "Name/BR/Nature of Business",
          errorMsg: "Vendor name, BR and Nature of Bussiness can not change at same time. Please reach out to vendor onboarding team for exceptions."
        });
        formValidateData.isValid = false;
      }
    }
  };

  useEffect(() => {
    if (fistSubmitDone) {
      validateData();
    }
    setPreparerData();
    //if individual payment and initial state popup
    if (vendorDetailMode === VendorRequestViewMode.VendorIndividualPay
      && vendorDetail.requestStatusId === RequestStatus.Initial) {
      handleVendoIndividualPayment(null, true);
    }
  }, [vendorDetail]);

  const getPromiseRequestSavedData = (reqnumber: string) => {
    return VendorDetailService.getVendorRequestData(
      reqnumber,
      sAPVendorNo,
      coCode,
      "",
      true,
      function (vendorRequestData: VendorCreateState) {
        dispatch({
          type: "ON_SUCCESS_VENDOR_REQUEST_GET",
          payload: vendorRequestData,
        });
        //compeletePareralRequests(true);        
      },
      function (error: Error) {
        //console.log(error);
        //compeletePareralRequests(false);
      }
    );
  };

  const getPromiseBlockedRequestData = (requestId: number) => {
    return VendorBlockingService.getSavedBlockingData(
      requestId,
      function (vendorBlockedData: VendorBlockinViewData) {
        //compeletePareralRequests(true);
        setBlockViewData(vendorBlockedData);
      },
      function (error: Error) {
        // console.log(error);
        //compeletePareralRequests(false);
      }
    );
  };
  const getPromiseExtendRequestData = (requestId: number) => {
    return VendorExtendService.getSavedExtendData(
      requestId,
      function (vendorExtendData: ExtendCompnayData[] | any[]) {
        if(vendorExtendData && vendorExtendData.length > 0){    
          vendorExtendData.forEach((ext) => {
            ext.paymentMethodCode = ext.paymentMethodCodes;
            ext.poCode = ext.poCodes;
          });
        }
        setExtendViewData(vendorExtendData);
      },
      function (error: Error) {
        // console.log(error);
        //compeletePareralRequests(false);
      }
    );
  };
  const getPromiseBlockExemptionRequestData = (requestId: number) => {
    return VendorBlockExcemptionService.getSavedBlockDetailData(
      requestId,
      function (vendorBlockExcemptionData: VendorBlockExcemptionViewData) {
        //compeletePareralRequests(true);
        setBlockExcemptionViewData(vendorBlockExcemptionData);
      },
      function (error: Error) {
        // console.log(error);
        //compeletePareralRequests(false);
      }
    );
  };

  const getHouseBank = (cocode: string) => {
    //prepareForRequest();
    return VendorMasterData.getHouseBank(
      //vendorDetail.companyCode,
      cocode,
      function (houseBankList: Array<HouseBank>) {
        setHousebanks(houseBankList);
        //compeleteRequest(true);
      },
      function (error: Error) {
        //console.log(error);
        setHousebanks([]);
        //compeleteRequest(false);
      }
    );
  };

  const getPurposeOfPayment = () => {
    //prepareForRequest();
    return VendorMasterData.getPurposeOfPaymentIndiaData(
      function (purposeOfPayList: Array<PurposeOfPayment>) {
        setPurposeList(purposeOfPayList);
        //compeleteRequest(true);
      },
      function (error: Error) {
        //console.log(error);
        setPurposeList([]);
        //compeleteRequest(false);
      }
    );
  };
  const validateBankKey = (bankdata: BankDetails) => {
    let details = bankdata.bankKey.name.split("|");
    let adress = Array<string>();
    let addrNo = details[5] ? details[5].trim() : "";
    let addrStreet = details[4] ? details[4].trim() : "";

    if (addrNo) {
      adress.push(addrNo);
    }

    if (addrStreet) {
      adress.push(addrStreet);
    }
    return (details[2] && details[2].trim() &&  //bankdata.bankName, bank name
      adress && adress.length > 0 && // bank address
      details[3] && details[3].trim() && // bank number- bank branch
      details[7] && details[7].trim()) ? true : false // swift code);
  };
  const getBankDetails = (bankCountry: string) => {
    //prepareForRequest();
    VendorMasterData.getBankDetails(
      //vendorDetail.AddressCoutry,
      bankCountry,
      function (bankDetail: Array<BankDetails>) {
        //setBanckackeys(bankkeys);
        if (bankDetail && bankDetail.length > 0) {
          bankDetail = bankDetail.filter((bnk) => {
            return validateBankKey(bnk);
          });
        }
        setBankDetails(bankDetail);
        // compeleteRequest(true);
      },
      function (error: Error) {
        console.log(error);
        //setBanckackeys([]);
        setBankDetails([]);
        // compeleteRequest(false);
      }
    );
  };

  const getWHTCodes = (whtCountry: string) => {
    //prepareForRequest();
    return VendorMasterData.getWHTCodes(
      //vendorDetail.WHTCountry,
      whtCountry,
      function (whtcodes: Array<WHTCode>) {
        setWhtcodes(whtcodes);
        //compeleteRequest(true);
      },
      function (error: Error) {
        //console.log(error);
        setWhtcodes([]);
        //compeleteRequest(false);
      }
    );
  };

  const getWHTTypes = (whtCountry: string) => {
    //prepareForRequest();
    return VendorMasterData.getWHTTypes(
      //vendorDetail.WHTCountry,
      whtCountry,
      function (whttypes: Array<WHTType>) {
        setWhttypes(whttypes);
        //compeleteRequest(true);
      },
      function (error: Error) {
        //console.log(error);
        setWhttypes([]);
        //compeleteRequest(false);
      }
    );
  };

  const getPreferedPaymentMethods = (
    cocode: string,
    addressCountry: string,
    onSuccess: Function,
    onError: Function
  ) => {
    //prepareForRequest();
    VendorMasterData.getPreferedPaymentMethods(
      //vendorDetail.companyCode,
      //vendorDetail.AddressCoutry,
      cocode,
      addressCountry,
      function (paymethodsList: Array<PaymentMethod>) {
        if (vendorDetailMode !== VendorRequestViewMode.VendorIndividualPay) {
          const i = paymethodsList.map((i: any) => i.code).indexOf('H');
          if (i > 0) {
            paymethodsList.splice(i, 1);
          }
        }
        onSuccess(paymethodsList);
        //setPaymentmethod(paymethodsList);
        //compeleteRequest(true);
      },
      function (error: Error) {
        onError(error);
        //console.log(error);
        //setPaymentmethod([]);
        //compeleteRequest(false);
      }
    );
  };

  const getRegonCodes = (addressCountry: string) => {
    //prepareForRequest();
    return VendorMasterData.getRegionCode(
      //vendorDetail.AddressCoutry,
      addressCountry,
      function (regionList: Array<RegionCode>) {
        setRegioncodes(regionList);
        //compeleteRequest(true);
      },
      function (error: Error) {
        //console.log(error);
        setRegioncodes([]);
        //compeleteRequest(false);
      }
    );
  };

  const getBankDetailMetaData = () => {
    return VendorMasterData.getBankDetailMetaData(
      function (bankData: VendorDetailBankDetailMeta) {
        setAcccorencies(bankData.accountCurencies);
        setSortcodes(bankData.sortKeys);
      },
      function (error: Error) {
        //console.log(error);
        setAcccorencies([]);
        setSortcodes([]);
      }
    );
  };

  const getPaymentDetailMetaData = (coCountryCode: string) => {
    return VendorMasterData.getPaymentDetailMetaData(
      coCountryCode,
      function (paymentData: VendorDetailPaymentMeta) {
        setTermstrade(paymentData.termsOfTrades);
        setCrediperioddays(paymentData.creditPeriodDays);
        setSettlementcurrency(paymentData.settlementCurencies);
        setSvattypes(paymentData.svatTypes);
        setWhtcountries(paymentData.whtCountries);
      },
      function (error: Error) {
        //console.log(error);
        setTermstrade([]);
        setCrediperioddays([]);
        setSettlementcurrency([]);
        setSvattypes([]);
        setWhtcountries([]);
      }
    );
  };

  const getContactDetailMetaData = () => {
    VendorMasterData.getContactDetailMetaData(
      function (contactData: VendorDetailContactMeta) {
        setComunctionmethods(contactData.communicationMethods);
        setCountries(contactData.country);
      },
      function (error: Error) {
        //console.log(error);
        setComunctionmethods([]);
        setCountries([]);
      }
    );
  };
  const getUOMMetaData = () => {
    VendorMasterData.getUOMMetaData(
      function (uomList: Array<UOM>) {
        //setUOMData(uomList); 
        setUOMData(uomList.map(obj => obj.code));
      },
      function (error: Error) {
        setUOMData([]);
      }
    );
  };



  const getBasicDetailMetaData = () => {
    VendorMasterData.getBasicDetailMetaData(
      function (basicData: VendorDetailBasicMeta) {
        setBsnature(basicData.natureOfBusinessList);
        setVendotitle(basicData.vendorTitleList);
      },
      function (error: Error) {
        //console.log(error);
        setBsnature([]);
        setVendotitle([]);
      }
    );
  };

  const getCompareVendorDetail = (requestId: number, vendorId: number) => {
    if (requestId && vendorId) {
      RequestService.GetCompareVendorRequest(requestId, vendorId,
        function (compareObj: any) {
          setVendorCompareObj(compareObj);
        },
        function (error: Error) {
          //console.log(error);
        }
      );
    }
  };

  const getCompareVendorBanksRequest = (vendorId: number) => {
    if (vendorId) {
      RequestService.GetCompareVendorBanksRequest(vendorId,
        function (compareBankObj: any) {
          //vendorCompareBankObj = compareBankObj;
          setVendorCompareBankObj(compareBankObj);
        },
        function (error: Error) {
          //console.log(error);
        }
      );
    }
  };

  useEffect(() => {
    if (vendorDetail.CompanyCode && vendorDetail.CompanyCode.code !== "") {
      if (!isInitialVendorDetailData) {
        prepareForRequest();
        Promise.allSettled([getHouseBank(vendorDetail.CompanyCode.code)]).then(
          (values) => {
            compeleteRequest(true);
          }
        );
      }
    } else {
      setHousebanks([]);
    }
  }, [vendorDetail.CompanyCode.code]);

  useEffect(() => {
    if (vendorDetail.AddressCoutry && vendorDetail.AddressCoutry !== "") {
      if (!isInitialVendorDetailData) {
        prepareForRequest();
        Promise.allSettled([
          getRegonCodes(vendorDetail.AddressCoutry),
          //getBankDetails(vendorDetail.AddressCoutry),
          getPreferedPaymentMethods(
            vendorDetail.CompanyCode.code,
            vendorDetail.AddressCoutry,
            (paymethodsList: Array<PaymentMethod>) => { setPaymentmethod(paymethodsList); },
            () => { setPaymentmethod([]); }
          ),
        ]).then((values) => {
          compeleteRequest(true);
        });
      }
    } else {
      //setBankDetails([]);
      setRegioncodes([]);
      setPaymentmethod([]);
    }
  }, [vendorDetail.AddressCoutry]);

  useEffect(() => {
    if (vendorDetail.bankCountry && vendorDetail.bankCountry !== "") {
      if (!isInitialVendorDetailData) {
        prepareForRequest();
        Promise.allSettled([getBankDetails(vendorDetail.bankCountry)]).then(
          (values) => {
            compeleteRequest(true);
          }
        );
      }
    } else {
      setBankDetails([]);
    }
  }, [vendorDetail.bankCountry]);

  useEffect(() => {
    let currH = currencyHouseBanks.find((element) => {
      return element.houseBank === vendorDetail.HouseBank;
    });
    dispatch(
      AllActions.vendorDetailActions.updateDataField(
        "currencyId",
        currH?.currencyCode
      ));
    let houseBanksList = currencyHouseBanks.filter((element) => {
      return element.currencyCode === currH?.currencyCode;
    });
    setSelectedHouseBanks(houseBanksList);
  }, [currencyHouseBanks]);

  useEffect(() => {
    if (vendorDetail.WHTCountry && vendorDetail.WHTCountry !== "") {
      if (!isInitialVendorDetailData) {
        prepareForRequest();
        Promise.allSettled([
          getWHTTypes(vendorDetail.WHTCountry),
          getWHTCodes(vendorDetail.WHTCountry),
        ]).then((values) => {
          compeleteRequest(true);
        });
      }
    } else {
      setWhttypes([]);
      setWhtcodes([]);
    }
  }, [vendorDetail.WHTCountry]);

  useEffect(() => {
    prepareForRequest();
    setIsInitialVendorDetailData(true);
    VendorDetailService.getVendorDetailData(
      requestId,
      sAPVendorNo,
      coCode,
      poCode,
      function (vendorData: VendorDetailState) {
        dispatch({
          type: "ON_SUCCESS_VENDOR_DETAIL_GET",
          payload: vendorData,
        });

        const additionalDocs = vendorData.additionalDocumentDetail || [];
        setUploadTableData(additionalDocs);

        dispatch(
          AllActions.vendorDetailActions.updateDataField(
            "additionalDocumentList",
            additionalDocs
          )
        );

        vendorDetailMode = vendorData.requestTypeId == RequestTypes.VendorAmend ? VendorRequestViewMode.VendorAmend
          : vendorData.requestTypeId == RequestTypes.VendorBlock ? VendorRequestViewMode.VendorBlock
            : vendorData.requestTypeId == RequestTypes.VendorExtend ? VendorRequestViewMode.VendorExtend
              : vendorData.requestTypeId == RequestTypes.VendorIndividualPay ? VendorRequestViewMode.VendorIndividualPay
                : vendorData.requestTypeId == RequestTypes.VendorBlockExcemption ? VendorRequestViewMode.VendorBlockExcemption
                  : VendorRequestViewMode.VendorCreate;
        Promise.allSettled([
          getPromiseRequestSavedData(vendorData.requestNumber),
          vendorDetailMode === VendorRequestViewMode.VendorBlock ||
            vendorDetailMode === VendorRequestViewMode.VendorUnBlock ? getPromiseBlockedRequestData(vendorData.requestId)
            : vendorDetailMode === VendorRequestViewMode.VendorExtend ? getPromiseExtendRequestData(vendorData.requestId)
              : vendorDetailMode === VendorRequestViewMode.VendorBlockExcemption ? getPromiseBlockExemptionRequestData(vendorData.requestId)
                : undefined,
          getCompareVendorDetail(vendorData.requestId, vendorData.vendorId),
          getCompareVendorBanksRequest(vendorData.vendorId),
          getBasicDetailMetaData(),
          getContactDetailMetaData(),
          getUOMMetaData(),
          //getUploadTypeData(),
          getPaymentDetailMetaData(vendorData.coCodes[0].countryCode),
          getPurposeOfPayment(),
          getBankDetailMetaData(),
          vendorData.whtCountry && vendorData.whtCountry !== ""
            ? getWHTTypes(vendorData.whtCountry)
            : undefined,
          vendorData.whtCountry && vendorData.whtCountry !== ""
            ? getWHTCodes(vendorData.whtCountry)
            : undefined,
          vendorData.addressCoutry && vendorData.addressCoutry !== ""
            ? getRegonCodes(vendorData.addressCoutry)
            : undefined,
          vendorData.bankCountry && vendorData.bankCountry !== ""
            ? getBankDetails(vendorData.bankCountry)
            : undefined,
          vendorData.addressCoutry && vendorData.addressCoutry !== ""
            ? getPreferedPaymentMethods(
              vendorData.coCodes[0].code,
              vendorData.addressCoutry,
              (paymethodsList: Array<PaymentMethod>) => { setPaymentmethod(paymethodsList); },
              () => { setPaymentmethod([]); }
            )
            : undefined,
          vendorData.coCodes[0] && vendorData.coCodes[0] !== ""
            ? getHouseBank(vendorData.coCodes[0].code)
            : undefined,
          /*  vendorDetail.additionalDocumentList = vendorData.additionalDocumentDetail,
           setUploadTableData(vendorData.additionalDocumentDetail), */
          console.log(vendorData.additionalDocumentDetail),
          console.log(vendorData.vendorCategoryId)
        ]).then((values) => {
          //setPreparerData();
          setIsInitialVendorDetailData(false);
          compeleteRequest(true);
          getCurrencyHouseBankData();

        });
      },
      function (error: Error) {
        // console.log(error);
        setIsInitialVendorDetailData(false);
        compeleteRequest(false);
      }
    );
    //}
  }, []);

  useEffect(() => {
    let vendorDetailOb = prepareVendorObjecteToSend();
    if (
      vendorDetail.IsSubmited &&
      vendorDetailMode === VendorRequestViewMode.VendorAmend
    ) {
      prepareForRequest();
      VendorAmendService.updateVendor(
        //vendorDetail,
        vendorDetailOb,
        function (vendorData: ResponseObject) {
          console.log(vendorData);
          if (vendorData.message) {
            dispatch(AllActions.vendorDetailActions.updateSubmitStatus(false));
            compeleteRequest(false, vendorData.message);
          } else {
            if (Common.isVendor()) {
              dispatch({
                type: "ON_SUCCESS_VENDOR_DETAIL_GET",
                payload: vendorData.result,
              });
            }
            compeleteRequest(
              true,
              translation.vendor_detail_amend_form2_submit_success_msg
            );

            if (!Common.isVendor()) {
              //setTimeout(() => {
              dispatch(AllActions.vendorDetailActions.resetVendorDetails());
              history.push(NavigationPaths.Dashboard);
              //}, 3 * 1000);
            }
          }
        },
        function (error: Error) {
          console.log(error);
          dispatch(AllActions.vendorDetailActions.updateSubmitStatus(false));
          compeleteRequest(
            false,
            translation.vendor_detail_amend_form2_submit_error_msg
          );
        }
      );
    }
    //ApprovalPointUtil.isInitialVendorDetailMode(vendorDetail.CurrentApprovalPointId, vendorDetail.requestStatusId)
    else if (
      vendorDetail.IsSubmited &&
      vendorDetailMode === VendorRequestViewMode.VendorCreate
    ) {
      prepareForRequest();
      VendorDetailService.updateVendor(
        //vendorDetail,
        vendorDetailOb,
        function (vendorData: ResponseObject) {
          console.log(vendorData);
          if (vendorData.message) {
            dispatch(AllActions.vendorDetailActions.updateSubmitStatus(false));
            compeleteRequest(false, vendorData.message);
          } else {
            if (Common.isVendor()) {
              dispatch({
                type: "ON_SUCCESS_VENDOR_DETAIL_GET",
                payload: vendorData.result,
              });
            }
            compeleteRequest(
              true,
              translation.vendor_detail_form2_submit_success_msg
            );
            if (!Common.isVendor()) {
              //setTimeout(() => {
              dispatch(AllActions.vendorDetailActions.resetVendorDetails());
              history.push(NavigationPaths.Dashboard);
              //}, 3 * 1000);
            }
          }
        },
        function (error: Error) {
          console.log(error);
          dispatch(AllActions.vendorDetailActions.updateSubmitStatus(false));
          compeleteRequest(
            false,
            translation.vendor_detail_form2_submit_error_msg
          );
        }
      );
    }
  }, [vendorDetail.IsSubmited]);

  const cancelRequest = () => {
    prepareForRequest();
    let cancelData: ApprovalStatusData = {
      requestId: vendorDetail?.requestId!,
      requestComment: vendorDetail.Comment,
      companyCountryCode: "",
      approvalStatusId: RequestStatus.Cancelled,
      approvalLevelId: vendorDetail?.currentApprovalPointId!,
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: false,
      isSendVerificationNotification: false,
      verifiedContactPersonName: "",
      vcExtendedInputs: {
        purposeCode: "",
        accountingClark: "",
        accountingClarkEmail: "",
        instructionKey: "",
        sortKey: "",
        isIndividualVendor: false
      },
      verifierDesignation: "",
      checkListItems: [],
      vendorTypeCode: createVendor?.VendorType,
      isTemporaryApproval: false,
      temporaryApprovalNoOfDays: ""
    };
    RequestService.SetApprovalStatus(
      cancelData,
      function (approvalRespone: ResponseObject) {
        if (
          approvalRespone &&
          (approvalRespone.resposeObjectType === ResponseObjectType.SAPError ||
            approvalRespone.resposeObjectType === ResponseObjectType.Error)
        ) {
          compeleteRequest(false, approvalRespone.message);
        } else if (
          approvalRespone &&
          approvalRespone.resposeObjectType === ResponseObjectType.SAPSuccess
        ) {
          compeleteRequest(
            true,
            translation.dashboard_vendor_request_cancel_suc
          );
          dispatch(AllActions.vendorDetailActions.resetVendorDetails());
          history.push(NavigationPaths.Dashboard);
        } else {
          compeleteRequest(
            true,
            translation.dashboard_vendor_request_cancel_suc
          );
          dispatch(AllActions.vendorDetailActions.resetVendorDetails());
          history.push(NavigationPaths.Dashboard);
        }
      },
      function (error: Error) {
        console.log(error);
        compeleteRequest(
          false,
          translation.dashboard_vendor_request_cancel_err
        );
      }
    );
  };

  const handleCancelRequest = (e: any) => {
    dispatch(
      AllActions.alertDialogActions.openAlertDialog(
        (vendorDetail.requestStatusId === RequestStatus.InitialSubmit ? translation.dashboard_revert_submit_req_con_title : translation.dashboard_cancelreq_con_title),
        (vendorDetail.requestStatusId === RequestStatus.InitialSubmit ? translation.dashboard_revert_submit_req_con_msg : translation.dashboard_cancelreq_con_msg),
        translation.dashboard_cancelreq_con_yesbtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
          cancelRequest();
        },
        translation.dashboard_cancelreq_con_nobtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
        }
      )
    );
  };

  const handleDownloadPdf = (e: any) => {
    return VendorDetailService.downloadPdf(vendorDetail.RequestNumber,
      function () {
        // dda
      },
      function (error: Error) {
        //dd 
      }
    );
  };

  const checkMobiValid = () => {
    if (!is2MobileSelected()) {
      formValidateData.errorsList.push({
        fieldName: "MobileNumbers",
        errorMsg: "2 selected contact numbers are required"
      });
    }
  };

  const handleInitialSubmit = (e: any) => {
    //set mobil selection 
    // if (vendorDetail.MobileNumbers.length == 2) {
    //   vendorDetail.MobileNumbers.forEach(function (contact: MobileNo) {
    //     contact.isChecked = true;
    //   });
    // }
    setFistSubmitDone(true);
    if (validateData()) {
      dispatch(AllActions.vendorDetailActions.updateSubmitStatus(true));
      //setIsSubmitted(true);
    } else {
      setOpenValidateErrDialog(true);
    }
  };

  const submitCreateRequest = () => {
    prepareForRequest();
    VendorDetailService.submitVendor(
      vendorDetail.requestId,
      function (responseData: ResponseObject) {
        if (responseData.message) {
          dispatch(AllActions.vendorDetailActions.updateSubmitStatus(false));
          compeleteRequest(false, responseData.message);
        } else {
          compeleteRequest(true, translation.vendor_detail_amend_form2_submit_success_msg);
          dispatch(AllActions.vendorDetailActions.resetVendorDetails());
          history.push(NavigationPaths.Dashboard);
        }
      },
      function (error: Error) {
        dispatch(AllActions.vendorDetailActions.updateSubmitStatus(false));
        compeleteRequest(false, translation.vendor_detail_amend_form2_submit_error_msg);
      }
    );
  };

  const submitAmendRequest = () => {
    prepareForRequest();
    VendorAmendService.submitVendor(
      vendorDetail.requestId,
      function (responseData: ResponseObject) {
        if (responseData.message) {
          dispatch(AllActions.vendorDetailActions.updateSubmitStatus(false));
          compeleteRequest(false, responseData.message);
        } else {
          compeleteRequest(true, translation.vendor_detail_amend_form2_submit_success_msg);
          dispatch(AllActions.vendorDetailActions.resetVendorDetails());
          history.push(NavigationPaths.Dashboard);
        }
      },
      function (error: Error) {
        dispatch(AllActions.vendorDetailActions.updateSubmitStatus(false));
        compeleteRequest(false, translation.vendor_detail_amend_form2_submit_error_msg);
      }
    );
  };

  const handleSubmit = (e: any) => {
    // if (vendorDetail.VendorSignedFile && vendorDetail.VendorSignedFile.fileId > 0) {
    var lst = uploadtableData.filter(row => row.uploadTypeId == FileUploadTypes.VendorSignedDoc);
    if (lst != null && lst != undefined && lst.length > 0) {
      if (lst[0].file && lst[0].file.fileId > 0) {
        if (vendorDetail.requestTypeId == RequestTypes.VendorCreate) {
          submitCreateRequest();
        } else if (vendorDetail.requestTypeId == RequestTypes.VendorAmend) {
          submitAmendRequest();
        }
      }
      else {
        dispatch(AllActions.infoActions.openInforError(translation.vendor_detail_signed_request_form_required, InforDisplyaDuration.common));
      }
    } else {
      dispatch(AllActions.infoActions.openInforError(translation.vendor_detail_signed_request_form_required, InforDisplyaDuration.common));
    }
    if (vendorDetail.requestTypeId == RequestTypes.VendorCreate) {

    } else if (vendorDetail.requestTypeId == RequestTypes.VendorCreate) {

    }
  };

  /*   const prepareVendorObjecteToSend = () => {
      //clone vendor data
      const vendorOb = JSON.parse(JSON.stringify(vendorDetail)) as VendorDetailState;
      //remove delete items from banks list
      vendorOb.bankDetailList = vendorOb.bankDetailList.filter(item => !(item.modifiedStatus === 2));
      vendorOb.bankDetailList.forEach((row) => {
        if (row.id < 0) {
          row.id = 0;
        }
      });
      return vendorOb;
    }; */


  const prepareVendorObjecteToSend = () => {
    // clone vendor data
    const vendorOb = JSON.parse(JSON.stringify(vendorDetail)) as VendorDetailState & {
      additionalDocumentList?: AdditionalDocumentDetail[];
      additionalDocumentDetail?: AdditionalDocumentDetail[];
      millEvaluationFormList?: MillEvaluationFormDetail[];
    };

    // remove deleted items from bank list
    vendorOb.bankDetailList = vendorOb.bankDetailList.filter(
      (item) => item.modifiedStatus !== 2
    );

    vendorOb.bankDetailList.forEach((row) => {
      if (row.id < 0) {
        row.id = 0;
      }
    });

    // IMPORTANT: include uploaded additional documents in payload
    vendorOb.additionalDocumentList = uploadtableData;
    vendorOb.additionalDocumentDetail = uploadtableData;

    // keep mill evaluation list too
    vendorOb.millEvaluationFormList = vendorDetail.millEvaluationFormList || [];

    return vendorOb;
  };

  const handleSave = (e: any) => {
    let vendorDetailOb = prepareVendorObjecteToSend();

    if (vendorDetailMode === VendorRequestViewMode.VendorAmend) {
      prepareForRequest();
      //if (validateVendorCommercialData(false)) {
      VendorAmendService.updateVendor(
        //vendorDetail,
        vendorDetailOb,
        function (vendorData: ResponseObject) {
          console.log(vendorData);
          if (vendorData.message) {
            compeleteRequest(false, vendorData.message);
          } else {
            getCompareVendorDetail(vendorDetailOb.requestId, vendorDetailOb.VendorId);
            getCompareVendorBanksRequest(vendorDetailOb.VendorId);
            dispatch({
              type: "ON_SUCCESS_VENDOR_DETAIL_GET",
              payload: vendorData.result,
            });
            compeleteRequest(
              true,
              translation.vendor_detail_amend_form2_save_success_msg
            );
          }
        },
        function (error: Error) {
          console.log(error);
          compeleteRequest(
            false,
            translation.vendor_detail_amend_form2_save_error_msg
          );
        }
      );
      //}
      //else {
      //  setOpenValidateErrDialog(true);
      //}
    } else {
      prepareForRequest();
      //if (validateVendorCommercialData(false)) {
      VendorDetailService.updateVendor(
        //vendorDetail,
        vendorDetailOb,
        function (vendorData: ResponseObject) {
          console.log(vendorData);
          if (vendorData.message) {
            compeleteRequest(false, vendorData.message);
          } else {
            getCompareVendorDetail(vendorDetailOb.requestId, vendorDetailOb.VendorId);
            getCompareVendorBanksRequest(vendorDetailOb.VendorId);
            dispatch({
              type: "ON_SUCCESS_VENDOR_DETAIL_GET",
              payload: vendorData.result,
            });
            compeleteRequest(
              true,
              translation.vendor_detail_form2_save_success_msg
            );

          }
        },
        function (error: Error) {
          console.log(error);
          compeleteRequest(
            false,
            translation.vendor_detail_form2_save_error_msg
          );
        }
      );
      // }
      //else {
      //  setOpenValidateErrDialog(true);
      //}
    }
  };

  const handleAttchemnets = (e: any) => {
    //open pop up
    prepareForRequest();
    FileDownloadService.getAttachmentList(
      vendorDetail.RequestNumber,
      function (attchemntData: any) {
        if (attchemntData && attchemntData.length > 0) {
          setAttachments(attchemntData);
          setOpenAttchmentsDialog(true);
          compeleteRequest(true);
        } else {
          compeleteRequest(false, translation.vendor_detail_nofiles_todownload);
        }
      },
      function (error: Error) {
        console.log(error);
        compeleteRequest(false);
      }
    );

    // setAttachments([]);
    // setOpenAttchmentsDialog(true)
  };

  const handleExtend = (e: any) => {
    history.push(NavigationPaths.VendorExtend, {
      vendorId: vendorDetail.VendorId,
      requestNumber: vendorDetail.RequestNumber,
    });
  };

  const onAproveRequestConfirm = (approvalLevelId: number) => {
    setOpenApprove(false);
    //update current aproval point
    dispatch(
      AllActions.vendorDetailActions.updateDataField(
        "CurrentApprovalPointId",
        approvalLevelId
      )
    );
    dispatch(AllActions.vendorDetailActions.resetVendorDetails());
    history.push(NavigationPaths.Dashboard);
  };

  const onAproveRequestCancel = () => {
    setOpenApprove(false);
  };

  const onApproveClose = () => {
    setOpenApprove(false);
  };

  const onEmailResendClick = (e: any) => {
    prepareForRequest();
    RequestService.ReSendVendorEmail(vendorDetail.requestId,
      (data) => {
        if (data) {
          compeleteRequest(true);
          dispatch(AllActions.infoActions.openInforSuccess("Invitation sent to the vendor successfully.", InforDisplyaDuration.common));
        }
      },
      (error) => {
        compeleteRequest(false);
      })
  };

  const onApproveClick = (e: any) => {
    setDataToApprove({
      requestId: vendorDetail.requestId,
      companyCountryCode: vendorDetail.CompanyCode.countryCode,
      approvalStatusId: 1,
      approvalLevelId: vendorDetail?.CurrentApprovalPointId!,
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: false,
      isSendVerificationNotification: false,
      verifiedContactPersonName: "",
      requestComment: vendorDetail.Comment,
      vcExtendedInputs: {
        purposeCode: vendorDetail.PurposeCode,
        accountingClark: ApprovalPointUtil.isSAPCreateOrAmendOrExtend(
          vendorDetail?.CurrentApprovalPointId!
        )
          ? vendorDetail?.AccoutingClark
          : "",
        accountingClarkEmail: ApprovalPointUtil.isSAPCreateOrAmendOrExtend(
          vendorDetail?.CurrentApprovalPointId!
        )
          ? vendorDetail?.AccoutingEmail
          : "",
        instructionKey: vendorDetail.InstructionKey,
        sortKey: vendorDetail.sortKey,
        isIndividualVendor: vendorDetail.isIndividualPayement
      },
      verifierDesignation: "",
      checkListItems: [],
      vendorTypeCode: createVendor?.VendorType,
      isTemporaryApproval: (vendorDetail?.tempApprovalDays && vendorDetail?.tempApprovalDays > 0) ? true : false,
      temporaryApprovalNoOfDays: (vendorDetail?.tempApprovalDays && vendorDetail?.tempApprovalDays > 0)
        ? vendorDetail?.tempApprovalDays?.toString() : ""
    });
    setOpenApprove(true);
  };

  const onRejectRequestConfirm = (approvalLevelId: number) => {
    //send aprove request
    setOpenReject(false);
    //update current aproval point
    dispatch(
      AllActions.vendorDetailActions.updateDataField(
        "approvalLevelId",
        approvalLevelId
      )
    );

    //setTimeout(() => {
    dispatch(AllActions.vendorDetailActions.resetVendorDetails());
    history.push(NavigationPaths.Dashboard);
    //}, 1 * 1000);
    //if(approvalLevelId === AppApprovalPoints.VCCallBack || approvalLevelId === AppApprovalPoints.VCCreate ){
    //  history.push(NavigationPaths.Dashboard);
    //}
  };

  const onRejectRequestCancel = () => {
    setOpenReject(false);
  };

  const onRejectClose = () => {
    setOpenReject(false);
  };

  const getIndividualPaymentData = () => {
    let houseB = currencyHouseBanks.find((ele: CurrencyHouseBank) =>
      ele.houseBank === vendorDetail.HouseBank);

    let data: IndividualPaymentRequestData = {
      departmentId: createVendor.DepartmentId,
      vendorId: vendorDetail.VendorId,
      vendorNo: vendorDetail.VendorNo,
      coCode: vendorDetail.CompanyCode.code,
      poCode: [],
      paymentMethodCode: vendorDetail.PrefPayMethod,
      comment: isIndividualPaymentEditMode ? vendorDetail.Comment : "",
      bankAccWithName: vendorDetail.supplierCBankName,
      isIndividualPayment: vendorDetail.isIndividualPayement,
      bankAccWithSwiftAddress: vendorDetail.supplierCBankAccountSWIFT,
      estSalesTurnover: vendorDetail.estimatedSalesTurnover,
      goodsDesc: vendorDetail.descOfGoods,
      hsCodes: vendorDetail.offShoreSupplierHSCode,
      noOfInvoices: vendorDetail.noOfInvoicesPerMonth,
      houseBank: vendorDetail.HouseBank,
      currencyId: houseB ? houseB.currencyCode : "",
      instructionKey: vendorDetail.InstructionKey
    };
    return data;
  };

  const onRejectClick = (e: any) => {
    setDataToApprove({
      requestId: vendorDetail.requestId,
      companyCountryCode: "",
      approvalStatusId: 2,
      approvalLevelId: vendorDetail?.CurrentApprovalPointId!,
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: false,
      isSendVerificationNotification: false,
      verifiedContactPersonName: "",
      requestComment: vendorDetail.Comment,
      vcExtendedInputs: {
        purposeCode: "",
        accountingClark: "",
        accountingClarkEmail: "",
        instructionKey: "",
        sortKey: "",
        isIndividualVendor: false
      },
      verifierDesignation: "",
      checkListItems: [],
      vendorTypeCode: createVendor?.VendorType,
      isTemporaryApproval: false,
      temporaryApprovalNoOfDays: ""
    });
    setOpenReject(true);
  };

  const isVendorEditAndForceEdit = () => {
    if (vendorDetail.requestStatusId == RequestStatus.Initial) {
      //navigate from dasboard to edit by Mas
      if (vendorDetail.isVendorFillForm2 && !(isForceEdit || Common.isVendor())) {
        return false;
      }
      return true;
    }
    return false;
  };

  const isEditableMode = () => {
    if (vendorDetailMode === VendorRequestViewMode.VendorCreate) {
      return isVendorEditAndForceEdit();
    }
    else if (vendorDetailMode === VendorRequestViewMode.VendorAmend) {
      return isVendorEditAndForceEdit();
    }
    return false;
  };

  const isFileEditable = (fileTypeId: number) => {
    return isEditableMode() 
      && fileTypeId != FileUploadTypes.OnboardingReasonDoc;
  };

  const hasAdditionalDocuments = () => {
    return (vendorDetail.SupportAdditionalFile1 && vendorDetail.SupportAdditionalFile1.fileId > 0)
      || (vendorDetail.SupportAdditionalFile2 && vendorDetail.SupportAdditionalFile2.fileId > 0);
  };

  const handleVendorExtend = (e: any) => {
    //setOpenExtend(true);
    let promises: Promise<void>[] = [];
    prepareForRequest();
    promises.push(VendorExtendService.getCompany(
      vendorId,
      function (companyData: Array<Company>) {
        let compData = companyData
          ? companyData.filter((c) => {
            return ApprovalPointUtil.isUserPermitedApprovalPoint(c.code, [AppApprovalPoints.VEInitial]);
          })
          : [];
        setRequestChangeCodeList(compData);
        if (companyData && companyData.length === 0) {
          compeleteRequest(false, translation.vendorchangepopup_metadata_err);
        }
      },
      function (error: Error) {
        console.log(error);
        setRequestChangeCodeList([]);
        compeleteRequest(false, translation.vendorchangepopup_metadata_err);
      }
    ));
    promises.push(VendorMasterData.getDepartments(
      function (departmentData: Array<Department>) {
        setDepartmentList(departmentData.filter((d: Department) => {
          return d.isActive;
        }));
      },
      function (error: Error) {
        console.log(error);
        setDepartmentList([]);
        compeleteRequest(false, translation.vendorchangepopup_metadata_err);
      }
    ));
    Promise.all(promises).then((values) => {
      compeleteRequest(true);
      setRequestchangeTitle(translation.vendorchangepopup_extend_title);
      setOpenRequestExtend(true);
    });
  };

  const handleVendoIndividualPayment = (e: any, isEditMode: boolean) => {
    setIsIndividualPaymentEditMode(isEditMode);
    let promises: Promise<void>[] = [];
    prepareForRequest();
    promises.push(VendorMasterData.getDepartments(
      function (departmentData: Array<Department>) {
        setDepartmentList(departmentData.filter((d: Department) => {
          return d.isActive;
        }));
      },
      function (error: Error) {
        console.log(error);
        setDepartmentList([]);
        compeleteRequest(false, translation.vendorchangepopup_metadata_err);
      }
    ));
    Promise.all(promises).then((values) => {
      compeleteRequest(true);
      setRequestchangeTitle(translation.individualPayPopup_title);
      setOpenIndividualPayment(true);
    });
  };

  const handleRequestExtendClose = (e: any) => {
    setOpenRequestExtend(false);
  };

  const handleIndividualPaymentClose = (e: any) => {
    //dont close the popup when click out side
    if (isIndividualPaymentEditMode) {
      e.preventDefault();
    } else {
      setOpenIndividualPayment(false);
    }
  };

  const handleIndividualPaymentCancel = (e: any) => {
    setOpenIndividualPayment(false);
    dispatch(AllActions.vendorDetailActions.resetVendorDetails());
    history.push(NavigationPaths.Dashboard);
  };

  const onRequestChangeConfirm = (e: any) => {
    history.push(NavigationPaths.Dashboard);
  };

  const handleDelete = (e: React.MouseEvent, value: string, input: string) => {
    e.preventDefault();
    if (input === "PrefPayMethod") {
      dispatch(AllActions.vendorDetailActions.removeFromPrefPayMethod(value));
    }
  };

  const handleDeleteDocument = (e: React.MouseEvent, value: number, uploadTypeIdVal: number, idVal: number) => {
    e.preventDefault();
    if (value != null && value != 0) {
      FileDownloadService.deleteAdditionalDocument(
        value,
        function (result: boolean) {
          if (result == true) {
            compeleteRequest(true, translation.vendor_detail_form2_doc_delete_success_msg);
            const updatedTableData = uploadtableData.filter((x) => x.file.fileId !== value);
            setUploadTableData(updatedTableData);
          } else {
            compeleteRequest(true, translation.vendor_detail_form2_doc_delete_error_msg);
          }
        },
        function (error: Error) {
          compeleteRequest(true, translation.vendor_detail_form2_doc_delete_error_msg);
        }
      );
    }
    else {
      //const tabledata = uploadtableData.filter(row => row.uploadTypeId == uploadTypeIdVal);
      const updatedTableData = uploadtableData.filter((x) => x.tempid !== idVal);
      setUploadTableData(updatedTableData);
      /* setUploadTableData({
      ...uploadtableData,
      [uploadTypeId]: uploadtableData.filter((cmp) => {
        return cmp.uploadTypeId !== uploadTypeIdVal;
      }), */
      //});
      //dispatch(AllActions.infoActions.openInforError(translation.vendor_detail_additionaldoc_cannot_delete_document, InforDisplyaDuration.common));

    }
  };

  const handleAddDocumentDetails = () => {
    if (selectedDocTypeId != null && selectedDocTypeId != undefined && selectedDocTypeId != 0) {

      //var newId = Math.max(...uploadtableData.map(row => row.tempid)) + 1; // Generate a new unique ID
      var newId = Date.now() + Math.floor(Math.random() * 1000);
      if (uploadtableData.length == 0) {
        //newId = 1;

        const newItem: AdditionalDocumentDetail = {
          tempid: newId,
          uploadType: docUploadTypes.filter((row) => row.id == selectedDocTypeId)[0].name,
          uploadTypeId: selectedDocTypeId,
          file: { fileId: 0, fileName: "", filePath: "" }
        };

        setUploadTableData([...uploadtableData, newItem]);
        setSelectedDocTypeId(0);
      }
      else {
        if (selectedDocTypeId == FileUploadTypes.VendorCodeOfConduct || selectedDocTypeId == FileUploadTypes.SpendOversightCriteria || selectedDocTypeId == FileUploadTypes.VendorSignedDoc) {
          const tabledata = uploadtableData.filter(row => row.uploadTypeId == selectedDocTypeId);
          if (tabledata == null || tabledata.length == 0 || tabledata == undefined) {

            const newItem: AdditionalDocumentDetail = {
              tempid: newId,
              uploadType: docUploadTypes.filter((row) => row.id == selectedDocTypeId)[0].name,
              uploadTypeId: selectedDocTypeId,
              file: { fileId: 0, fileName: "", filePath: "" }
            };

            setUploadTableData([...uploadtableData, newItem]);
            setSelectedDocTypeId(0);
          }
          else {
            dispatch(AllActions.infoActions.openInforError(translation.vendor_detail_additionaldoc_select_onedocumentallowed, InforDisplyaDuration.common));
          }
        }
        else {

          const newItem: AdditionalDocumentDetail = {
            tempid: newId,
            uploadType: docUploadTypes.filter((row) => row.id == selectedDocTypeId)[0].name,
            uploadTypeId: selectedDocTypeId,
            file: { fileId: 0, fileName: "", filePath: "" }
          };

          setUploadTableData([...uploadtableData, newItem]);
          setSelectedDocTypeId(0);
        }
      }

    }
    else {
      dispatch(AllActions.infoActions.openInforError(translation.vendor_detail_additionaldoc_select_doctype, InforDisplyaDuration.common));
    }
  };

  const handleDocTypeChange = () => (e: any, value: any) => {
    setSelectedDocTypeId(e.target.value);
  };

  const getUploadTypeData = () => {
    setDocUploadTypes([]);
    const newItem1 = { id: FileUploadTypes.CopiesOfMandatoryCertificates, name: translation.vendor_detail_additionaldoc_uploadtype_copiesofManadatoryCertificates };
    const newItem2 = { id: FileUploadTypes.VendorCodeOfConduct, name: translation.vendor_detail_additionaldoc_uploadtype_vendorcodeofconduct };
    const newItem3 = { id: FileUploadTypes.SpendOversightCriteria, name: translation.vendor_detail_additionaldoc_uploadtype_spendoversightcriteria };
    const newItem4 = { id: FileUploadTypes.VendorSignedDoc, name: translation.vendor_detail_additionaldoc_uploadtype_vendorsigneddoc };
    const newItem5 = { id: FileUploadTypes.Other, name: translation.vendor_detail_additionaldoc_uploadtype_other };

    if (!vendorDetail.isVendorFillForm2 && vendorDetail.requestStatusId != RequestStatus.Initial
      && (vendorDetail.requestTypeId === RequestTypes.VendorCreate
        || vendorDetail.requestTypeId === RequestTypes.VendorAmend)) {
      setDocUploadTypes(prevItems => [...prevItems, newItem4]);
    }
    else if (isEditableMode()) {
      if (vendorDetail.vendorCategoryId == VendorCategoryData.RM) {
        setDocUploadTypes(prevItems => [...prevItems, newItem1]);
        setDocUploadTypes(prevItems => [...prevItems, newItem2]);
        setDocUploadTypes(prevItems => [...prevItems, newItem5]);
      }
      else if (isEditableMode() && (vendorDetail.vendorCategoryId == VendorCategoryData.NonRM || vendorDetail.vendorCategoryId == VendorCategoryData.Services)) {
        setDocUploadTypes(prevItems => [...prevItems, newItem1]);
        setDocUploadTypes(prevItems => [...prevItems, newItem2]);
        setDocUploadTypes(prevItems => [...prevItems, newItem3]);
        setDocUploadTypes(prevItems => [...prevItems, newItem5]);
      }
      else {
        setDocUploadTypes(prevItems => [...prevItems, newItem5]);
      }

    }

  };

  const propsitems = {
    getErrorState,
    handleChange,
    handleDelete,
    prepareForRequest,
    compeleteRequest,
    isAvailableForVendorCountry,
    vendorDetailMode,
    vendorId,
    sAPVendorNo,
    isDisplayRegistrationNumber,
    isPORequest,
    //isSwiftCodeRequired,
    //isSortCodeRequired,
    isBankDetaildRequired,
    handleOnBlur,
    isWHTAvailable,
    isPanTaxRequired,
    isTrcRequired,
    isTaxDetailsAvailable,
    is1099Required,
    isFielsAvailable
  };

  return (
    <div>
      {//vendorDetail.requestStatusId === RequestStatus.Initial &&
        vendorDetail.rejectReason && (
          // <div style={{ float: "left",  width: "100%" }}>
          //   <div>{translation.vendor_detail_rejectreason}
          //   <AssignmentLateOutlinedIcon></AssignmentLateOutlinedIcon></div>
          //   <div> {vendorDetail.rejectReason}</div>
          // </div>
          <div className={classes.rejectedBox}>
            <Grid container item xs={12} sm={12} md={12} lg={12}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Grid item></Grid>
                <Grid item></Grid>
                <div className={classes.rejectedLbl}>
                  {translation.vendor_detail_rejectreason}
                  {/* <AssignmentLateOutlinedIcon></AssignmentLateOutlinedIcon> */}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.textWrap}>
                  {vendorDetail.rejectReason}
                </span>
              </Grid>
            </Grid>
          </div>
          // <div>
          //   {translation.vendor_detail_rejectreason} : {vendorDetail.rejectReason}
          // </div>
        )}
      {(!Common.isVendor()) && (<Accordion className={classes.accwrapper} defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.accHeader}
        >
          <Typography>{translation.vendor_detail_form1_title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className={classes.accowrapperReadOnly}>
            <Form1Data {...propsitems}
              getCompareField={getCompareField}
            ></Form1Data>
          </div>
        </AccordionDetails>
      </Accordion>)}
      {(vendorDetailMode === VendorRequestViewMode.VendorBlock ||
        vendorDetailMode === VendorRequestViewMode.VendorUnBlock) && (
          <Accordion className={classes.accwrapper} defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={classes.accHeader}
            >
              <Typography>
                {vendorDetailMode === VendorRequestViewMode.VendorBlock
                  ? translation.vendor_detail_blocking_title
                  : translation.vendor_detail_unblocking_title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className={classes.accowrapperReadOnly}>
                <BlockData
                  blockData={blockViewData}
                  vendorDetailMode={vendorDetailMode}
                ></BlockData>
              </div>
            </AccordionDetails>
          </Accordion>
        )}
      {(vendorDetailMode === VendorRequestViewMode.VendorExtend && extendViewData && extendViewData.length > 0) && (
        <Accordion className={classes.accwrapper} defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accHeader}>
            <Typography>
              {translation.vendor_detail_extend_title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.accowrapperReadOnly}>
              <ExtendData
                extendList={extendViewData}
              ></ExtendData>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
      {(vendorDetailMode === VendorRequestViewMode.VendorBlockExcemption) && (
        <Accordion className={classes.accwrapper} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className={classes.accHeader}
          >
            <Typography>
              {vendorDetailMode === VendorRequestViewMode.VendorBlockExcemption
                ? translation.vendor_detail_blockexception_title
                : ""}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.accowrapperReadOnly}>
              <BlockExcemptionData
                blockExcemptionData={blockExcemptionViewData}
                vendorDetailMode={vendorDetailMode}
              ></BlockExcemptionData>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
      {(vendorDetailMode == VendorRequestViewMode.VendorCreate
        || vendorDetailMode == VendorRequestViewMode.VendorAmend)
        && (<Accordion className={classes.accwrapper} defaultExpanded >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accHeader} >
            <Typography>{translation.vendor_detail_preparer_title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <PreparerInfo
                {...propsitems}
                getCompareField={getCompareField}
                isEditableMode={isEditableMode()}
              ></PreparerInfo>
            </div>
          </AccordionDetails>
        </Accordion>)}
      {(vendorDetailMode == VendorRequestViewMode.VendorCreate
        || vendorDetailMode == VendorRequestViewMode.VendorAmend)
        && (ApprovalPointUtil.isCallerVerificationDone(vendorDetail.CurrentApprovalPointId))
        && (<Accordion className={classes.accwrapper} defaultExpanded >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accHeader} >
            <Typography>{translation.vendor_detail_caller_verifier_title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <CallerVerifierInfo
              ></CallerVerifierInfo>
            </div>
          </AccordionDetails>
        </Accordion>)}
      {(vendorDetailMode === VendorRequestViewMode.VendorIndividualPay) && (
        <Accordion
          className={classes.accwrapper}
          defaultExpanded
        //expanded={expanded === "basicdata"}
        // onChange={handleAccordingChange("basicdata")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className={classes.accHeader}
          >
            <Typography>{translation.vendor_detail_indivitial_payment_title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <IndividualPaymentInfo
                {...propsitems}
                getCompareField={getCompareField}
                bsnature={bsnature}
                vendotitle={vendotitle}
                isEditableMode={isEditableMode()}
              ></IndividualPaymentInfo>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
      <Accordion
        className={classes.accwrapper}
        defaultExpanded
      //expanded={expanded === "basicdata"}
      // onChange={handleAccordingChange("basicdata")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.accHeader}
        >
          <Typography>{translation.vendor_detail_basic_title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <BascInfo
              {...propsitems}
              getCompareField={getCompareField}
              bsnature={bsnature}
              vendotitle={vendotitle}
              isEditableMode={isEditableMode()}
            ></BascInfo>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className={classes.accwrapper}
        defaultExpanded
      //expanded={expanded === "contactdetail"}
      //onChange={handleAccordingChange("contactdetail")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.accHeader}
        >
          <Typography>
            {translation.vendor_detail_contactdetails_title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div
          // className={
          //   !isEditableMode() ? classes.compDisableCls : ""
          // }
          >
            <ContactDetail
              {...propsitems}
              isEditableMode={isEditableMode()}
              getCompareField={getCompareField}
              comunctionmethods={comunctionmethods}
              countries={countries}
              regioncodes={regioncodes}
              isRegionRequired={isRegionRequired}
            ></ContactDetail>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className={classes.accwrapper}
        defaultExpanded
      //expanded={expanded === "paymentdetail"}
      //onChange={handleAccordingChange("paymentdetail")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.accHeader}
        >
          <Typography>
            {translation.vendor_detail_paymentdetails_title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <PaymentDetail
              {...propsitems}
              isEditableMode={isEditableMode()}
              getCompareField={getCompareField}
              termstrade={termstrade}
              crediperioddays={crediperioddays}
              settlementcurrency={settlementcurrency}
              svattypes={svattypes}
              whtcountries={whtcountries}
              whttypes={whttypes}
              whtcodes={whtcodes}
              paymentmethod={paymentmethod}
            ></PaymentDetail>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className={classes.accwrapper}
        defaultExpanded
      //expanded={expanded === "bankdetail"}
      // onChange={handleAccordingChange("bankdetail")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.accHeader}
        >
          <Typography>{translation.vendor_detail_bankdetails_title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div /*className={!isEditableMode() ? classes.compDisableCls : ""}*/>
            <BankDetail
              {...propsitems}
              isEditableMode={isEditableMode()}
              acccorencies={acccorencies}
              sortcodes={sortcodes}
              housebanks={housebanks}
              purposelist={purposeList}
              bankDetails={bankDetails}
              countries={countries}
              getCompareField={getCompareField}
              getBankGridCompareField={getBankGridCompareField}
              currencyHouseBanks={currencyHouseBanks}
              selectedHouseBanks={selectedHouseBanks}
            ></BankDetail>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* ------------ Vendor Commercials start*/}
      {/* {(vendorDetail.vendorCategoryId == VendorCategoryData.RM || vendorDetail.vendorCategoryId == VendorCategoryData.NonRM || vendorDetail.vendorCategoryId == VendorCategoryData.Services) &&
        (vendorDetail.isBulk) &&
        <Accordion
          className={classes.accwrapper}
          defaultExpanded
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className={classes.accHeader}
          >
            <Typography>{translation.vendor_detail_commercials_title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <Commercial
                {...propsitems}
                isEditableMode={isEditableMode()}
                uomData={uomData}
              ></Commercial>
            </div>
          </AccordionDetails>
        </Accordion>
      } */}

      {/* ------------ Vendor Commercials End */}
      {/* ------------ Mill Evaluation Form start*/}
      {(vendorDetail.vendorCategoryId == VendorCategoryData.RM) && <Accordion
        className={classes.accwrapper}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.accHeader}
        >
          <Typography>{translation.vendor_detail_millevaluationform_title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <MillEvaluationForm
              {...propsitems}
              isEditableMode={isEditableMode()}
            //uomData={uomData}
            ></MillEvaluationForm>
          </div>
        </AccordionDetails>
      </Accordion>
      }
      {/* ------------ Mill Evaluation Form End */}
      <Accordion className={classes.accwrapper} defaultExpanded >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accHeader} >
          <Typography>{translation.vendor_detail_additional_doc_title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>
            {/* <Grid container spacing={2} item xs={12} sm={12} md={11} lg={12} className={classes.formOneWrapper}>
              <Grid item xs={12} sm={12} md={6} lg={4} >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.formTwoLbl}>
                    {translation.vendor_detail_bankdetails_extra1upload_lbl}
                  </span>
                </Grid>
                <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                  <div className={classes.fileWrapper}>
                    <FileUpload
                      editable={isEditableMode()}
                      requestNumber={vendorDetail.RequestNumber}
                      userfile={vendorDetail.Extra1File}
                      attachmentType={FileUploadTypes.ExtraDocument_1}
                    ></FileUpload>
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.formTwoLbl}>
                    {translation.vendor_detail_bankdetails_extra2upload_lbl}
                  </span>
                </Grid>
                <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                  <div className={classes.fileWrapper}>
                    <FileUpload
                      editable={isEditableMode()}
                      requestNumber={vendorDetail.RequestNumber}
                      userfile={vendorDetail.Extra2File}
                      attachmentType={FileUploadTypes.ExtraDocument_2}
                    ></FileUpload>
                  </div>
                </Grid>
              </Grid>
              {(hasAdditionalDocuments() || ApprovalPointUtil.isSupportDocumentAny(vendorDetail.CurrentApprovalPointId)) && (
                <Fragment>
                  <Grid item xs={12} sm={12} md={6} lg={4} >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.formTwoLbl}>
                        {translation.vendor_detail_additional_support_doc1_lbl}
                      </span>
                    </Grid>
                    <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                      <div className={classes.fileWrapper}>
                        <FileUpload
                          editable={ApprovalPointUtil.isSupportDocumentAny(vendorDetail.CurrentApprovalPointId)}
                          requestNumber={vendorDetail.RequestNumber}
                          userfile={vendorDetail.SupportAdditionalFile1}
                          attachmentType={FileUploadTypes.SupportDoc_1}
                        ></FileUpload>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.formTwoLbl}>
                        {translation.vendor_detail_additional_support_doc2_lbl}
                      </span>
                    </Grid>
                    <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                      <div className={classes.fileWrapper}>
                        <FileUpload
                          editable={ApprovalPointUtil.isSupportDocumentAny(vendorDetail.CurrentApprovalPointId)}
                          requestNumber={vendorDetail.RequestNumber}
                          userfile={vendorDetail.SupportAdditionalFile2}
                          attachmentType={FileUploadTypes.SupportDoc_2}
                        ></FileUpload>
                      </div>
                    </Grid>
                  </Grid>
                </Fragment>)}
              {(!vendorDetail.isVendorFillForm2 && vendorDetail.requestStatusId != RequestStatus.Initial
                && (vendorDetail.requestTypeId === RequestTypeLabel.VendorCreate
                  || vendorDetail.requestTypeId === RequestTypeLabel.VendorAmend)) &&
                (<Grid item xs={12} sm={12} md={6} lg={4} >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.formTwoLbl}>
                      {translation.vendor_detail_vendor_signed_doc_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                    <div className={classes.fileWrapper}>
                      <FileUpload
                        editable={vendorDetail.requestStatusId === RequestStatus.InitialSubmit}
                        requestNumber={vendorDetail.RequestNumber}
                        userfile={vendorDetail.VendorSignedFile}
                        attachmentType={FileUploadTypes.VendorSignedDoc}
                      ></FileUpload>
                    </div>
                  </Grid>
                </Grid>)
              }
            </Grid> */}
            {/* ---New Upload Area Start--------- */}


            <Grid container spacing={2} item xs={12} sm={12} md={11} lg={12}>
              <div className={classes.tblOuterBG} style={{ width: "100%" }}>
                <Paper>
                  <TableContainer className={classes.tblContainer}>
                    <Table
                      size="small"
                      stickyHeader
                      aria-label="sticky table"
                      style={{ minWidth: "100px" }}
                    >
                      <TableHead className={classes.tblHeader}>
                        <TableRow>
                          {uploadtableColumnData.map((column, index) => {
                            return (
                              <TableCell style={{ minWidth: "100px" }}>
                                {column.name}
                              </TableCell>
                            );
                          })}
                          {<TableCell style={{ minWidth: "79px" }}></TableCell>}

                        </TableRow>
                      </TableHead>
                      <TableBody className={classes.tblBody}>
                        <TableRow>
                          <TableCell style={{ width: "50%" }}>
                            <Grid className={classes.formOneinputWrapper}
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                            >
                              <div style={{ width: "60%" }}>
                                <Select
                                  variant="outlined"
                                  value={selectedDocTypeId || ""}
                                  onChange={handleDocTypeChange()}
                                >
                                  {docUploadTypes.map((obj: DocumentTypeData, index: number) => (
                                    <MenuItem key={obj.id} value={obj.id}>
                                      {obj.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </div>
                            </Grid>
                          </TableCell>
                          <TableCell>
                            <div style={{ width: "35%", float: "left" }}>
                              <Button onClick={handleAddDocumentDetails}>
                                <AddCircleIcon style={{ fill: "#19C626", width: "32px", height: "32px" }}></AddCircleIcon>

                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                        {uploadtableData &&
                          uploadtableData.map((row, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell style={{ width: "30%" }}>
                                  {row.uploadType}
                                </TableCell>
                                <TableCell style={{ width: "40%" }}>
                                  <Grid item xs={12} sm={12} md={6} lg={4} >
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                      <span className={classes.formTwoLbl}>
                                        {row.uploadType}
                                      </span>
                                    </Grid>
                                    {row.uploadTypeId == FileUploadTypes.VendorSignedDoc && (
                                      <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                                        <div className={classes.fileWrapper} style={{ width: "300%" }}>
                                          <FileUpload
                                            editable={vendorDetail.requestStatusId === RequestStatus.InitialSubmit}
                                            requestNumber={vendorDetail.RequestNumber}
                                            userfile={row.file}
                                            attachmentType={row.uploadTypeId}
                                          ></FileUpload>
                                        </div>
                                      </Grid>
                                    )}
                                    {(row.uploadTypeId == FileUploadTypes.Other 
                                      || row.uploadTypeId == FileUploadTypes.VendorCodeOfConduct
                                      || row.uploadTypeId == FileUploadTypes.SpendOversightCriteria 
                                      || row.uploadTypeId == FileUploadTypes.CopiesOfMandatoryCertificates
                                      || row.uploadTypeId == FileUploadTypes.OnboardingReasonDoc) && (
                                        <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                                          <div className={classes.fileWrapper} style={{ width: "300%" }}>
                                            <FileUpload
                                              editable={isFileEditable(row.uploadTypeId)}
                                              requestNumber={vendorDetail.RequestNumber}
                                              userfile={row.file}
                                              attachmentType={row.uploadTypeId}
                                            ></FileUpload>
                                          </div>
                                        </Grid>
                                      )}
                                  </Grid>
                                </TableCell>
                                <TableCell style={{ width: "30%" }}>
                                  {(row.uploadTypeId == FileUploadTypes.Other
                                    || row.uploadTypeId == FileUploadTypes.VendorCodeOfConduct
                                    || row.uploadTypeId == FileUploadTypes.SpendOversightCriteria
                                    || row.uploadTypeId == FileUploadTypes.CopiesOfMandatoryCertificates) && (
                                      <Grid item xs={12} sm={12} md={12} lg={12}>
                                        {isFileEditable(row.uploadTypeId) ? (
                                          <div className={classes.rejectBtn}>
                                            <button onClick={(e) => handleDeleteDocument(e, row.file.fileId, row.uploadTypeId, row.tempid)}>
                                              <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                                            </button>
                                          </div>) : <div></div>}
                                      </Grid>
                                    )}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </div>
            </Grid>
            {/* ---New Upload Area end--------- */}
          </div>
        </AccordionDetails>
      </Accordion>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "30px 0 0 0" }} >
        <div>
          {vendorDetailMode === VendorForm1Modes.VendorInitialIndividualPay && (
            <div className={classes.greenBtnWrapper}>
              <Button onClick={(e: any) => { handleVendoIndividualPayment(e, false) }}>
                <ExtensionIcon></ExtensionIcon>
                {translation.vendor_detail_individual_payment_lbl}
              </Button>
            </div>
          )}
          {/* vendorDetailMode === VendorRequestViewMode.VendorExtend */}
          {vendorDetailMode === VendorForm1Modes.VendorInialExtend && (
            <div className={classes.greenBtnWrapper}>
              <Button onClick={handleVendorExtend}>
                <ExtensionIcon></ExtensionIcon>
                {translation.vendor_detail_extendbtn_lbl}
              </Button>
            </div>
          )}
          {/* {ApprovalPointUtil.isVendorAprovalEnable(vendorDetail.CurrentApprovalPointId, vendorDetail.requestStatusId) && */}
          {vendorDetail.requestStatusId === RequestStatus.Pending &&
            ApprovalPointUtil.isRequestApprovable(
              vendorDetail.CompanyCode.code,
              [vendorDetail.CurrentApprovalPointId],
              vendorDetail.ApproverNames
            ) && (
              <div>
                <div className={classes.greenBtnWrapper}>
                  <Button onClick={onApproveClick}>
                    <CheckCircleIcon></CheckCircleIcon>
                    {translation.vendor_detail_aprovbtn_lbl}
                  </Button>
                </div>
                <div className={classes.redBtnWrapper}>
                  <Button onClick={onRejectClick}>
                    <BlockIcon></BlockIcon>
                    {translation.vendor_detail_rejectbtn_lbl}
                  </Button>
                </div>
              </div>
            )}
          {/* {(ApprovalPointUtil.isInitialVendorDetailMode(vendorDetail.CurrentApprovalPointId, vendorDetail.requestStatusId) || 
          vendorDetailMode === VendorRequestViewMode.VendorAmend) && */}
          {vendorDetail.requestStatusId === RequestStatus.Initial && (
            <div>
              {isEditableMode() && (<>
                <div className={classes.greenBtnWrapper}>
                  <Button onClick={handleInitialSubmit}>
                    <CheckCircleIcon></CheckCircleIcon>
                    {translation.vendor_detail_submitbtn_lbl}
                  </Button>
                </div>
                <div className={classes.greenBtnWrapper}>
                  <Button onClick={handleSave}>
                    <CheckCircleIcon></CheckCircleIcon>
                    {translation.vendor_detail_savebtn_lbl}
                  </Button>
                </div>
              </>)}
              {vendorDetail.isVendorFillForm2 && !Common.isVendor() && (<div className={classes.greenBtnWrapper}>
                <Button onClick={onEmailResendClick}>
                  <EmailIcon></EmailIcon>
                  {translation.vendor_detail_email_resend_lbl}
                </Button>
              </div>)}
              {!Common.isVendor() && (<div className={classes.grayBtnWrapper}>
                <Button onClick={handleCancelRequest}>
                  <CancelIcon></CancelIcon>
                  cancel
                </Button>
              </div>)}
            </div>
          )}
          {(vendorDetail.requestStatusId === RequestStatus.InitialSubmit
            && (vendorDetailMode == VendorRequestViewMode.VendorCreate
              || vendorDetailMode == VendorRequestViewMode.VendorAmend)) && (
              <Fragment>
                <div className={classes.greenBtnWrapper}>
                  <Button onClick={handleSubmit}>
                    <CheckCircleIcon></CheckCircleIcon>
                    {translation.vendor_detail_submitbtn_lbl}
                  </Button>
                </div>
                <div className={classes.greenBtnWrapper}>
                  <Button onClick={handleDownloadPdf}>
                    <CheckCircleIcon></CheckCircleIcon>
                    {translation.vendor_detail_pdfdownloadbtn_lbl}
                  </Button>
                </div>
                <div className={classes.grayBtnWrapper}>
                  <Button onClick={handleCancelRequest}>
                    <CancelIcon></CancelIcon>
                    cancel
                  </Button>
                </div>
              </Fragment>)
          }
        </div>
      </Grid>
      {/* <FileDownload
        open={openAttchmentsDialog}
        setOpen={setOpenAttchmentsDialog}
        files={attchments}
      ></FileDownload> */}
      <ApproveDialog
        dataToApprove={dataToApprove!}
        setDataToApprove={setDataToApprove}
        open={openApprove}
        title={translation.dashboard_approve_title}
        message={translation.dashboard_approve_message}
        btnOnetext={translation.dashboard_approve_yesbtn}
        btnTwotext={translation.dashboard_reject_nobtn}
        onApproveConfirm={onAproveRequestConfirm}
        onApproveCancel={onAproveRequestCancel}
        handleClose={onApproveClose}
      ></ApproveDialog>
      <RejectDialog
        dataToReject={dataToApprove!}
        open={openReject}
        title={translation.dashboard_reject_title}
        message={translation.dashboard_reject_message}
        btnOnetext={translation.dashboard_reject_yesbtn}
        btnTwotext={translation.dashboard_reject_nobtn}
        onRejectConfirm={onRejectRequestConfirm}
        onRejectCancel={onRejectRequestCancel}
        handleClose={onRejectClose}
      ></RejectDialog>
      <ValidationErrors
        open={openValidateErrDialog}
        setOpen={setOpenValidateErrDialog}
        errorList={formErrors}
      ></ValidationErrors>
      {/* <VendorExtendPopUp open={openExtend} onUpdateConfirm={onExtendConfirm}
          vendorId={vendorId} companyCodeList={extendcompanyCodeList} handleClose={handleExtendClose}></VendorExtendPopUp> */}
      {createVendor.vendorNo && (
        <RequestExtendPopUp
          open={openRequestExtend}
          requestMode={VendorForm1Modes.VendorInialExtend}
          title={requestchangeTitle}
          onUpdateConfirm={onRequestChangeConfirm}
          vendorId={vendorId}
          vendorNo={sAPVendorNo}
          countryCode={vendorDetail.AddressCoutry}
          companyCodeList={requestChangeCodeList}
          departmentList={departmentList}
          companyCode={coCode}
          poCodeList={poCode}
          vendorType={createVendor.VendorType}
          handleClose={handleRequestExtendClose}
          countries={countries}
          onboardingReasonList={[]}
          procurementCategoryList={[]}
          procurementSubCategorySummaryList={[]}
          rmCategoryList={[]}
          instructionKeyList={[]}
        //approver1Lable=""
        //approver2Lable=""
        //approver1List={[]}
        //approver2List={[]}
        ></RequestExtendPopUp>)}
      <IndividualPaymentDialog
        open={openIndividualPayment}
        title={requestchangeTitle}
        isEditMode={isIndividualPaymentEditMode}
        requestId={isIndividualPaymentEditMode ? vendorDetail.requestId : null}
        vendorId={vendorId}
        vendorNo={sAPVendorNo}
        paymentMethods={paymentmethod}
        departmentList={departmentList}
        handleClose={handleIndividualPaymentClose}
        handleCancel={handleIndividualPaymentCancel}
        onUpdateConfirm={onRequestChangeConfirm}
        countryCode={vendorDetail.AddressCoutry}
        companyCode={coCode}
        individualPaymentData={getIndividualPaymentData()}
        instructionkeys={instructionkeys}
        currencyHouseBanks={currencyHouseBanks}
      />
    </div>
  );
} 
